// Auto-generated by generateThreatActors.js - Do not edit manually
export interface ThreatActor {
    id: string;
    name: string;
    fileName: string;
    severity: 'critical' | 'high' | 'medium' | 'low';
    country: string;
    firstSeen: string;
    description: string;
    aliases: string[];
    objectives: string[];
    industries: string[];
    techniques: { id: string; name: string }[];
}

export const threatActors: ThreatActor[] = [
    {
        "id": "G0001",
        "name": "Axiom",
        "fileName": "G0001-Axiom.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0001) is a suspected Chinese cyber espionage group that has targeted the aerospace, defense, government, manufacturing, and media sectors since at least 2008. Some reporting suggests a degree of overlap between (https://attack.mitre.org/groups/G0001) and (https://attack.mitre.org/groups/G0044) but the two groups appear to be distinct based on differences in reporting on TTPs and targeting.(Citation: Kaspersky Winnti April 2013)(Citation: Kaspersky Winnti June 2015)(Citation: Novetta Winnti April 2015)",
        "aliases": [
            "Group 72"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Defense",
            "Aerospace",
            "Manufacturing",
            "Media"
        ],
        "techniques": [
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1584.005",
                "name": "Botnet"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1553",
                "name": "Subvert Trust Controls"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1583.002",
                "name": "DNS Server"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1563.002",
                "name": "RDP Hijacking"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1566",
                "name": "Phishing"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1001.002",
                "name": "Steganography"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0002",
        "name": "Moafee",
        "fileName": "G0002-Moafee.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0002) is a threat group that appears to operate from the Guandong Province of China. Due to overlapping TTPs, including similar custom tools, Moafee is thought to have a direct or indirect relationship with the threat group (https://attack.mitre.org/groups/G0017). (Citation: Haq 2014)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            }
        ]
    },
    {
        "id": "G0003",
        "name": "Cleaver",
        "fileName": "G0003-Cleaver.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0003) is a threat group that has been attributed to Iranian actors and is responsible for activity tracked as Operation Cleaver. (Citation: Cylance Cleaver) Strong circumstantial evidence suggests Cleaver is linked to Threat Group 2889 (TG-2889). (Citation: Dell Threat Group 2889)",
        "aliases": [
            "Threat Group 2889",
            "TG-2889"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1557.002",
                "name": "ARP Cache Poisoning"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            }
        ]
    },
    {
        "id": "G0004",
        "name": "Ke3chang",
        "fileName": "G0004-Ke3chang.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0004) is a threat group attributed to actors operating out of China. (https://attack.mitre.org/groups/G0004) has targeted oil, government, diplomatic, military, and NGOs in Central and South America, the Caribbean, Europe, and North America since at least 2010.(Citation: Mandiant Operation Ke3chang November 2014)(Citation: NCC Group APT15 Alive and Strong)(Citation: APT15 Intezer June 2018)(Citation: Microsoft NICKEL December 2021)",
        "aliases": [
            "APT15",
            "Mirage",
            "Vixen Panda",
            "GREF",
            "Playful Dragon",
            "RoyalAPT",
            "NICKEL",
            "Nylon Typhoon"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1614.001",
                "name": "System Language Discovery"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1558.001",
                "name": "Golden Ticket"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1020",
                "name": "Automated Exfiltration"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1213.002",
                "name": "Sharepoint"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1036.002",
                "name": "Right-to-Left Override"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1583.005",
                "name": "Botnet"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1078.004",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            }
        ]
    },
    {
        "id": "G0005",
        "name": "APT12",
        "fileName": "G0005-APT12.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0005) is a threat group that has been attributed to China. The group has targeted a variety of victims including but not limited to media outlets, high-tech companies, and multiple governments.(Citation: Meyers Numbered Panda)",
        "aliases": [
            "IXESHE",
            "DynCalc",
            "Numbered Panda",
            "DNSCALC"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government",
            "Media"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1568.003",
                "name": "DNS Calculation"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            }
        ]
    },
    {
        "id": "G0006",
        "name": "APT1",
        "fileName": "G0006-APT1.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0006) is a Chinese threat group that has been attributed to the 2nd Bureau of the People’s Liberation Army (PLA) General Staff Department’s (GSD) 3rd Department, commonly known by its Military Unit Cover Designator (MUCD) as Unit 61398. (Citation: Mandiant APT1)",
        "aliases": [
            "Comment Crew",
            "Comment Group",
            "Comment Panda"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1114.001",
                "name": "Local Email Collection"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1584.001",
                "name": "Domains"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            }
        ]
    },
    {
        "id": "G0007",
        "name": "APT28",
        "fileName": "G0007-APT28.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0007) is a threat group that has been attributed to Russia's General Staff Main Intelligence Directorate (GRU) 85th Main Special Service Center (GTsSS) military unit 26165.(Citation: NSA/FBI Drovorub August 2020)(Citation: Cybersecurity Advisory GRU Brute Force Campaign July 2021) This group has been active since at least 2004.(Citation: DOJ GRU Indictment Jul 2018)(Citation: Ars Technica GRU indictment Jul 2018)(Citation: Crowdstrike DNC June 2016)(Citation: FireEye APT28)(Citation: SecureWorks TG-4127)(Citation: FireEye APT28 January 2017)(Citation: GRIZZLY STEPPE JAR)(Citation: Sofacy DealersChoice)(Citation: Palo Alto Sofacy 06-2018)(Citation: Symantec APT28 Oct 2018)(Citation: ESET Zebrocy May 2019)",
        "aliases": [
            "IRON TWILIGHT",
            "SNAKEMACKEREL",
            "Swallowtail",
            "Group 74",
            "Sednit",
            "Sofacy",
            "Pawn Storm",
            "Fancy Bear",
            "STRONTIUM",
            "Tsar Team",
            "Threat Group-4127",
            "TG-4127",
            "Forest Blizzard",
            "FROZENLAKE",
            "GruesomeLarch"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1589.001",
                "name": "Credentials"
            },
            {
                "id": "T1591",
                "name": "Gather Victim Org Information"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1596",
                "name": "Search Open Technical Databases"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1048.002",
                "name": "Exfiltration Over Asymmetric Encrypted Non-C2 Protocol"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1584.008",
                "name": "Network Devices"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1037.001",
                "name": "Logon Script (Windows)"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1567",
                "name": "Exfiltration Over Web Service"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1669",
                "name": "Wi-Fi Networks"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1110.001",
                "name": "Password Guessing"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1546.015",
                "name": "Component Object Model Hijacking"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1557.004",
                "name": "Evil Twin"
            },
            {
                "id": "T1498",
                "name": "Network Denial of Service"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1598",
                "name": "Phishing for Information"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1078.004",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1213.002",
                "name": "Sharepoint"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1025",
                "name": "Data from Removable Media"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1213",
                "name": "Data from Information Repositories"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1542.003",
                "name": "Bootkit"
            },
            {
                "id": "T1071.003",
                "name": "Mail Protocols"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1014",
                "name": "Rootkit"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1550.001",
                "name": "Application Access Token"
            },
            {
                "id": "T1030",
                "name": "Data Transfer Size Limits"
            },
            {
                "id": "T1134.001",
                "name": "Token Impersonation/Theft"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1092",
                "name": "Communication Through Removable Media"
            },
            {
                "id": "T1098.002",
                "name": "Additional Email Delegate Permissions"
            },
            {
                "id": "T1040",
                "name": "Network Sniffing"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1137.002",
                "name": "Office Test"
            },
            {
                "id": "T1528",
                "name": "Steal Application Access Token"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1001.001",
                "name": "Junk Data"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1211",
                "name": "Exploitation for Stealth"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            },
            {
                "id": "T1588.007",
                "name": "Artificial Intelligence"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0008",
        "name": "Carbanak",
        "fileName": "G0008-Carbanak.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0008) is a cybercriminal group that has used (https://attack.mitre.org/software/S0030) malware to target financial institutions since at least 2013. (https://attack.mitre.org/groups/G0008) may be linked to groups tracked separately as (https://attack.mitre.org/groups/G0080) and (https://attack.mitre.org/groups/G0046) that have also used (https://attack.mitre.org/software/S0030) malware.(Citation: Kaspersky Carbanak)(Citation: FireEye FIN7 April 2017)(Citation: Europol Cobalt Mar 2018)(Citation: Secureworks GOLD NIAGARA Threat Profile)(Citation: Secureworks GOLD KINGSWOOD Threat Profile)",
        "aliases": [
            "Anunak"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            }
        ]
    },
    {
        "id": "G0009",
        "name": "Deep Panda",
        "fileName": "G0009-Deep Panda.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0009) is a suspected Chinese threat group known to target many industries, including government, defense, financial, and telecommunications. (Citation: Alperovitch 2014) The intrusion into healthcare company Anthem has been attributed to (https://attack.mitre.org/groups/G0009). (Citation: ThreatConnect Anthem) This group is also known as Shell Crew, WebMasters, KungFu Kittens, and PinkPanther. (Citation: RSA Shell Crew) (https://attack.mitre.org/groups/G0009) also appears to be known as Black Vine based on the attribution of both group names to the Anthem intrusion. (Citation: Symantec Black Vine) Some analysts track (https://attack.mitre.org/groups/G0009) and (https://attack.mitre.org/groups/G0073) as the same group, but it is unclear from open source information if the groups are the same. (Citation: ICIT China's Espionage Jul 2016)",
        "aliases": [
            "Shell Crew",
            "WebMasters",
            "KungFu Kittens",
            "PinkPanther",
            "Black Vine"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Healthcare",
            "Financial",
            "Government",
            "Defense",
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            }
        ]
    },
    {
        "id": "G0010",
        "name": "Turla",
        "fileName": "G0010-Turla.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0010) is a cyber espionage threat group that has been attributed to Russia's Federal Security Service (FSB).  They have compromised victims in over 50 countries since at least 2004, spanning a range of industries including government, embassies, military, education, research and pharmaceutical companies. (https://attack.mitre.org/groups/G0010) is known for conducting watering hole and spearphishing campaigns, and leveraging in-house tools and malware, such as (https://attack.mitre.org/software/S0022).(Citation: Kaspersky Turla)(Citation: ESET Gazer Aug 2017)(Citation: CrowdStrike VENOMOUS BEAR)(Citation: ESET Turla Mosquito Jan 2018)(Citation: Joint Cybersecurity Advisory AA23-129A Snake Malware May 2023)",
        "aliases": [
            "IRON HUNTER",
            "Group 88",
            "Waterbug",
            "WhiteBear",
            "Snake",
            "Krypton",
            "Venomous Bear",
            "Secret Blizzard",
            "BELUGASTURGEON"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1584.006",
                "name": "Web Services"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1069.001",
                "name": "Local Groups"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1134.002",
                "name": "Create Process with Token"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1546.013",
                "name": "PowerShell Profile"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1555.004",
                "name": "Windows Credential Manager"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1615",
                "name": "Group Policy Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1071.003",
                "name": "Mail Protocols"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1564.012",
                "name": "File/Path Exclusions"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1025",
                "name": "Data from Removable Media"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1213.006",
                "name": "Databases"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1027.011",
                "name": "Fileless Storage"
            },
            {
                "id": "T1547.004",
                "name": "Winlogon Helper DLL"
            },
            {
                "id": "T1553.006",
                "name": "Code Signing Policy Modification"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1584.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1201",
                "name": "Password Policy Discovery"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            }
        ]
    },
    {
        "id": "G0011",
        "name": "PittyTiger",
        "fileName": "G0011-PittyTiger.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0011) is a threat group believed to operate out of China that uses multiple different types of malware to maintain command and control.(Citation: Bizeul 2014)(Citation: Villeneuve 2014)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            }
        ]
    },
    {
        "id": "G0012",
        "name": "Darkhotel",
        "fileName": "G0012-Darkhotel.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0012) is a suspected South Korean threat group that has targeted victims primarily in East Asia since at least 2004. The group's name is based on cyber espionage operations conducted via hotel Internet networks against traveling executives and other select guests. (https://attack.mitre.org/groups/G0012) has also conducted spearphishing campaigns and infected victims through peer-to-peer and file sharing networks.(Citation: Kaspersky Darkhotel)(Citation: Securelist Darkhotel Aug 2015)(Citation: Microsoft Digital Defense FY20 Sept 2020)",
        "aliases": [
            "DUBNIUM",
            "Zigzag Hail"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1497.002",
                "name": "User Activity Based Checks"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1080",
                "name": "Taint Shared Content"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            },
            {
                "id": "T1497",
                "name": "Virtualization/Sandbox Evasion"
            },
            {
                "id": "T1497.001",
                "name": "System Checks"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            }
        ]
    },
    {
        "id": "G0013",
        "name": "APT30",
        "fileName": "G0013-APT30.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0013) is a threat group suspected to be associated with the Chinese government. While (https://attack.mitre.org/groups/G0019) shares some characteristics with (https://attack.mitre.org/groups/G0013), the two groups do not appear to be exact matches.(Citation: FireEye APT30)(Citation: Baumgartner Golovkin Naikon 2015)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            }
        ]
    },
    {
        "id": "G0014",
        "name": "Night Dragon",
        "fileName": "G0014-Night Dragon.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0014) is a campaign name for activity involving a threat group that has conducted activity originating primarily in China. (Citation: McAfee Night Dragon)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0015",
        "name": "Taidoor",
        "fileName": "G0015-Taidoor.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0015) has been deprecated, as the only technique it was linked to was deprecated in ATT&CK v7.",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0016",
        "name": "APT29",
        "fileName": "G0016-APT29.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0016) is threat group that has been attributed to Russia's Foreign Intelligence Service (SVR).(Citation: White House Imposing Costs RU Gov April 2021)(Citation: UK Gov Malign RIS Activity April 2021) They have operated since at least 2008, often targeting government networks in Europe and NATO member countries, research institutes, and think tanks. (https://attack.mitre.org/groups/G0016) reportedly compromised the Democratic National Committee starting in the summer of 2015.(Citation: F-Secure The Dukes)(Citation: GRIZZLY STEPPE JAR)(Citation: Crowdstrike DNC June 2016)(Citation: UK Gov UK Exposes Russia SolarWinds April 2021)",
        "aliases": [
            "IRON RITUAL",
            "IRON HEMLOCK",
            "NobleBaron",
            "Dark Halo",
            "NOBELIUM",
            "UNC2452",
            "YTTRIUM",
            "The Dukes",
            "Cozy Bear",
            "CozyDuke",
            "SolarStorm",
            "Blue Kitsune",
            "UNC3524",
            "Midnight Blizzard"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1621",
                "name": "Multi-Factor Authentication Request Generation"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1090.004",
                "name": "Domain Fronting"
            },
            {
                "id": "T1528",
                "name": "Steal Application Access Token"
            },
            {
                "id": "T1568",
                "name": "Dynamic Resolution"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1136.003",
                "name": "Cloud Account"
            },
            {
                "id": "T1098.005",
                "name": "Device Registration"
            },
            {
                "id": "T1587.003",
                "name": "Digital Certificates"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1651",
                "name": "Cloud Administration Command"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1078.004",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1037",
                "name": "Boot or Logon Initialization Scripts"
            },
            {
                "id": "T1027.006",
                "name": "HTML Smuggling"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1550.003",
                "name": "Pass the Ticket"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1556.007",
                "name": "Hybrid Identity"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1037.004",
                "name": "RC Scripts"
            },
            {
                "id": "T1021.007",
                "name": "Cloud Services"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1586.003",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1573",
                "name": "Encrypted Channel"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1110.001",
                "name": "Password Guessing"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1665",
                "name": "Hide Infrastructure"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1553.005",
                "name": "Mark-of-the-Web Bypass"
            },
            {
                "id": "T1087.004",
                "name": "Cloud Account"
            },
            {
                "id": "T1098.002",
                "name": "Additional Email Delegate Permissions"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1059.009",
                "name": "Cloud API"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1685.002",
                "name": "Disable or Modify Cloud Log"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1649",
                "name": "Steal or Forge Authentication Certificates"
            }
        ]
    },
    {
        "id": "G0017",
        "name": "DragonOK",
        "fileName": "G0017-DragonOK.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0017) is a threat group that has targeted Japanese organizations with phishing emails. Due to overlapping TTPs, including similar custom tools, (https://attack.mitre.org/groups/G0017) is thought to have a direct or indirect relationship with the threat group (https://attack.mitre.org/groups/G0002). (Citation: Operation Quantum Entanglement) It is known to use a variety of malware, including Sysget/HelloBridge, PlugX, PoisonIvy, FormerFirstRat, NFlog, and NewCT. (Citation: New DragonOK)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0018",
        "name": "admin@338",
        "fileName": "G0018-admin@338.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0018) is a China-based cyber threat group. It has previously used newsworthy events as lures to deliver malware and has primarily targeted organizations involved in financial, economic, and trade policy, typically using publicly available RATs such as (https://attack.mitre.org/software/S0012), as well as some non-public backdoors. (Citation: FireEye admin@338)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1069.001",
                "name": "Local Groups"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            }
        ]
    },
    {
        "id": "G0019",
        "name": "Naikon",
        "fileName": "G0019-Naikon.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0019) is assessed to be a state-sponsored cyber espionage group attributed to the Chinese People’s Liberation Army’s (PLA) Chengdu Military Region Second Technical Reconnaissance Bureau (Military Unit Cover Designator 78020).(Citation: CameraShy) Active since at least 2010, (https://attack.mitre.org/groups/G0019) has primarily conducted operations against government, military, and civil organizations in Southeast Asia, as well as against international bodies such as the United Nations Development Programme (UNDP) and the Association of Southeast Asian Nations (ASEAN).(Citation: CameraShy)(Citation: Baumgartner Naikon 2015) ",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1137.006",
                "name": "Add-ins"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            }
        ]
    },
    {
        "id": "G0020",
        "name": "Equation",
        "fileName": "G0020-Equation.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0020) is a sophisticated threat group that employs multiple remote access tools. The group is known to use zero-day exploits and has developed the capability to overwrite the firmware of hard disk drives. (Citation: Kaspersky Equation QA)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1564.005",
                "name": "Hidden File System"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1480.001",
                "name": "Environmental Keying"
            },
            {
                "id": "T1542.002",
                "name": "Component Firmware"
            }
        ]
    },
    {
        "id": "G0021",
        "name": "Molerats",
        "fileName": "G0021-Molerats.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0021) is an Arabic-speaking, politically-motivated threat group that has been operating since 2012. The group's victims have primarily been in the Middle East, Europe, and the United States.(Citation: DustySky)(Citation: DustySky2)(Citation: Kaspersky MoleRATs April 2019)(Citation: Cybereason Molerats Dec 2020)",
        "aliases": [
            "Operation Molerats",
            "Gaza Cybergang"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1218.007",
                "name": "Msiexec"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            }
        ]
    },
    {
        "id": "G0022",
        "name": "APT3",
        "fileName": "G0022-APT3.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0022) is a China-based threat group that researchers have attributed to China's Ministry of State Security.(Citation: FireEye Clandestine Wolf)(Citation: Recorded Future APT3 May 2017) This group is responsible for the campaigns known as Operation Clandestine Fox, Operation Clandestine Wolf, and Operation Double Tap.(Citation: FireEye Clandestine Wolf)(Citation: FireEye Operation Double Tap) As of June 2015, the group appears to have shifted from targeting primarily US victims to primarily political organizations in Hong Kong.(Citation: Symantec Buckeye)",
        "aliases": [
            "Gothic Panda",
            "Pirpi",
            "UPS Team",
            "Buckeye",
            "Threat Group-0110",
            "TG-0110"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1104",
                "name": "Multi-Stage Channels"
            },
            {
                "id": "T1110.002",
                "name": "Password Cracking"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1098.007",
                "name": "Additional Local or Domain Groups"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1069",
                "name": "Permission Groups Discovery"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1036.010",
                "name": "Masquerade Account Name"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            }
        ]
    },
    {
        "id": "G0023",
        "name": "APT16",
        "fileName": "G0023-APT16.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0023) is a China-based threat group that has launched spearphishing campaigns targeting Japanese and Taiwanese organizations. (Citation: FireEye EPS Awakens Part 2)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1584.004",
                "name": "Server"
            }
        ]
    },
    {
        "id": "G0024",
        "name": "Putter Panda",
        "fileName": "G0024-Putter Panda.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0024) is a Chinese threat group that has been attributed to Unit 61486 of the 12th Bureau of the PLA’s 3rd General Staff Department (GSD). (Citation: CrowdStrike Putter Panda)",
        "aliases": [
            "APT2",
            "MSUpdater"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            }
        ]
    },
    {
        "id": "G0025",
        "name": "APT17",
        "fileName": "G0025-APT17.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0025) is a China-based threat group that has conducted network intrusions against U.S. government entities, the defense industry, law firms, information technology companies, mining companies, and non-government organizations. (Citation: FireEye APT17)",
        "aliases": [
            "Deputy Dog"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government",
            "Defense",
            "Technology"
        ],
        "techniques": [
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1585",
                "name": "Establish Accounts"
            }
        ]
    },
    {
        "id": "G0026",
        "name": "APT18",
        "fileName": "G0026-APT18.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0026) is a threat group that has operated since at least 2009 and has targeted a range of industries, including technology, manufacturing, human rights groups, government, and medical. (Citation: Dell Lateral Movement)",
        "aliases": [
            "TG-0416",
            "Dynamite Panda",
            "Threat Group-0416"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government",
            "Technology",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1053.002",
                "name": "At"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            }
        ]
    },
    {
        "id": "G0027",
        "name": "Threat Group-3390",
        "fileName": "G0027-Threat Group-3390.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0027) is a Chinese threat group that has extensively used strategic Web compromises to target victims.(Citation: Dell TG-3390) The group has been active since at least 2010 and has targeted organizations in the aerospace, government, defense, technology, energy, manufacturing and gambling/betting sectors.(Citation: SecureWorks BRONZE UNION June 2017)(Citation: Securelist LuckyMouse June 2018)(Citation: Trend Micro DRBControl February 2020)",
        "aliases": [
            "Earth Smilodon",
            "TG-3390",
            "Emissary Panda",
            "BRONZE UNION",
            "APT27",
            "Iron Tiger",
            "LuckyMouse",
            "Linen Typhoon"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Energy",
            "Government",
            "Defense",
            "Aerospace",
            "Technology",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1030",
                "name": "Data Transfer Size Limits"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1053.002",
                "name": "At"
            },
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1555.005",
                "name": "Password Managers"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1608.004",
                "name": "Drive-by Target"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1560.002",
                "name": "Archive via Library"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1070.005",
                "name": "Network Share Connection Removal"
            },
            {
                "id": "T1021.006",
                "name": "Windows Remote Management"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1685.001",
                "name": "Disable or Modify Windows Event Log"
            },
            {
                "id": "T1608.002",
                "name": "Upload Tool"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0028",
        "name": "Threat Group-1314",
        "fileName": "G0028-Threat Group-1314.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0028) is an unattributed threat group that has used compromised credentials to log into a victim's remote access infrastructure. (Citation: Dell TG-1314)",
        "aliases": [
            "TG-1314"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1072",
                "name": "Software Deployment Tools"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            }
        ]
    },
    {
        "id": "G0029",
        "name": "Scarlet Mimic",
        "fileName": "G0029-Scarlet Mimic.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0029) is a threat group that has targeted minority rights activists. This group has not been directly linked to a government source, but the group's motivations appear to overlap with those of the Chinese government. While there is some overlap between IP addresses used by (https://attack.mitre.org/groups/G0029) and (https://attack.mitre.org/groups/G0024), it has not been concluded that the groups are the same. (Citation: Scarlet Mimic Jan 2016)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1036.002",
                "name": "Right-to-Left Override"
            }
        ]
    },
    {
        "id": "G0030",
        "name": "Lotus Blossom",
        "fileName": "G0030-Lotus Blossom.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0030) is a long-standing threat group largely targeting various entities in Asia since at least 2009. In addition to government and related targets, (https://attack.mitre.org/groups/G0030) has also targeted entities such as digital certificate issuers.(Citation: Lotus Blossom Jun 2015)(Citation: Symantec Bilbug 2022)(Citation: Cisco LotusBlossom 2025)",
        "aliases": [
            "DRAGONFISH",
            "Spring Dragon",
            "RADIUM",
            "Raspberry Typhoon",
            "Bilbug",
            "Thrip"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1134",
                "name": "Access Token Manipulation"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1539",
                "name": "Steal Web Session Cookie"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1482",
                "name": "Domain Trust Discovery"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            }
        ]
    },
    {
        "id": "G0031",
        "name": "Dust Storm",
        "fileName": "G0031-Dust Storm.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0031) is a threat group that has targeted multiple industries in Japan, South Korea, the United States, Europe, and several Southeast Asian countries. (Citation: Cylance Dust Storm)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0032",
        "name": "Lazarus Group",
        "fileName": "G0032-Lazarus Group.html",
        "severity": "high",
        "country": "North Korea",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0032) is a North Korean state-sponsored cyber threat group attributed to the Reconnaissance General Bureau (RGB). (Citation: US-CERT HIDDEN COBRA June 2017) (Citation: Treasury North Korean Cyber Groups September 2019) (https://attack.mitre.org/groups/G0032) has been active since at least 2009 and is reportedly responsible for the November 2014 destructive wiper attack on Sony Pictures Entertainment, identified by Novetta as part of Operation Blockbuster. Malware used by (https://attack.mitre.org/groups/G0032) correlates to other reported campaigns, including Operation Flame, Operation 1Mission, Operation Troy, DarkSeoul, and Ten Days of Rain.(Citation: Novetta Blockbuster)",
        "aliases": [
            "Labyrinth Chollima",
            "HIDDEN COBRA",
            "Guardians of Peace",
            "ZINC",
            "NICKEL ACADEMY",
            "Diamond Sleet"
        ],
        "objectives": [
            "Espionage",
            "Destructive"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1202",
                "name": "Indirect Command Execution"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1001.003",
                "name": "Protocol or Service Impersonation"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1010",
                "name": "Application Window Discovery"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1134.002",
                "name": "Create Process with Token"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1098",
                "name": "Account Manipulation"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1485",
                "name": "Data Destruction"
            },
            {
                "id": "T1591",
                "name": "Gather Victim Org Information"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1027.009",
                "name": "Embedded Payloads"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1104",
                "name": "Multi-Stage Channels"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1489",
                "name": "Service Stop"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1588.004",
                "name": "Digital Certificates"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1620",
                "name": "Reflective Code Loading"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1036.003",
                "name": "Rename Legitimate Utilities"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1557.001",
                "name": "Name Resolution Poisoning and SMB Relay"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1561.001",
                "name": "Disk Content Wipe"
            },
            {
                "id": "T1491.001",
                "name": "Internal Defacement"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1547.009",
                "name": "Shortcut Modification"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1542.003",
                "name": "Bootkit"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1218",
                "name": "System Binary Proxy Execution"
            },
            {
                "id": "T1560.002",
                "name": "Archive via Library"
            },
            {
                "id": "T1027.007",
                "name": "Dynamic API Resolution"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1008",
                "name": "Fallback Channels"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1561.002",
                "name": "Disk Structure Wipe"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1070",
                "name": "Indicator Removal"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1574.013",
                "name": "KernelCallbackTable"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1529",
                "name": "System Shutdown/Reboot"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1070.003",
                "name": "Clear Command History"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1686.003",
                "name": "Windows Host Firewall"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            }
        ]
    },
    {
        "id": "G0033",
        "name": "Poseidon Group",
        "fileName": "G0033-Poseidon Group.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0033) is a Portuguese-speaking threat group that has been active since at least 2005. The group has a history of using information exfiltrated from victims to blackmail victim companies into contracting the (https://attack.mitre.org/groups/G0033) as a security firm. (Citation: Kaspersky Poseidon Group)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0034",
        "name": "Sandworm Team",
        "fileName": "G0034-Sandworm Team.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0034) is a destructive threat group that has been attributed to Russia's General Staff Main Intelligence Directorate (GRU) Main Center for Special Technologies (GTsST) military unit 74455.(Citation: US District Court Indictment GRU Unit 74455 October 2020)(Citation: UK NCSC Olympic Attacks October 2020) This group has been active since at least 2009.(Citation: iSIGHT Sandworm 2014)(Citation: CrowdStrike VOODOO BEAR)(Citation: USDOJ Sandworm Feb 2020)(Citation: NCSC Sandworm Feb 2020)",
        "aliases": [
            "ELECTRUM",
            "Telebots",
            "IRON VIKING",
            "BlackEnergy (Group)",
            "Quedagh",
            "Voodoo Bear",
            "IRIDIUM",
            "Seashell Blizzard",
            "FROZENBARENTS",
            "APT44"
        ],
        "objectives": [
            "Destructive"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1588.006",
                "name": "Vulnerabilities"
            },
            {
                "id": "T1040",
                "name": "Network Sniffing"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1586.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1213.006",
                "name": "Databases"
            },
            {
                "id": "T1539",
                "name": "Steal Web Session Cookie"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1072",
                "name": "Software Deployment Tools"
            },
            {
                "id": "T1584.005",
                "name": "Botnet"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1589.003",
                "name": "Employee Names"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1583.004",
                "name": "Server"
            },
            {
                "id": "T1590.001",
                "name": "Domain Properties"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1489",
                "name": "Service Stop"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1499",
                "name": "Endpoint Denial of Service"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1561.002",
                "name": "Disk Structure Wipe"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1592.002",
                "name": "Software"
            },
            {
                "id": "T1491.002",
                "name": "External Defacement"
            },
            {
                "id": "T1583",
                "name": "Acquire Infrastructure"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1594",
                "name": "Search Victim-Owned Websites"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1591.002",
                "name": "Business Relationships"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1490",
                "name": "Inhibit System Recovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1485",
                "name": "Data Destruction"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1195",
                "name": "Supply Chain Compromise"
            },
            {
                "id": "T1593",
                "name": "Search Open Websites/Domains"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1087.003",
                "name": "Email Account"
            }
        ]
    },
    {
        "id": "G0035",
        "name": "Dragonfly",
        "fileName": "G0035-Dragonfly.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0035) is a cyber espionage group that has been attributed to Russia's Federal Security Service (FSB) Center 16.(Citation: DOJ Russia Targeting Critical Infrastructure March 2022)(Citation: UK GOV FSB Factsheet April 2022) Active since at least 2010, (https://attack.mitre.org/groups/G0035) has targeted defense and aviation companies, government entities, companies related to industrial control systems, and critical infrastructure sectors worldwide through supply chain, spearphishing, and drive-by compromise attacks.(Citation: Symantec Dragonfly)(Citation: Secureworks IRON LIBERTY July 2019)(Citation: Symantec Dragonfly Sept 2017)(Citation: Fortune Dragonfly 2.0 Sept 2017)(Citation: Gigamon Berserk Bear October 2021)(Citation: CISA AA20-296A Berserk Bear December 2020)(Citation: Symantec Dragonfly 2.0 October 2017)",
        "aliases": [
            "TEMP.Isotope",
            "DYMALLOY",
            "Berserk Bear",
            "TG-4192",
            "Crouching Yeti",
            "IRON LIBERTY",
            "Energetic Bear",
            "Ghost Blizzard",
            "BROMINE"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1564.002",
                "name": "Hidden Users"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1591.002",
                "name": "Business Relationships"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1110.002",
                "name": "Password Cracking"
            },
            {
                "id": "T1608.004",
                "name": "Drive-by Target"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1598.002",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1036.010",
                "name": "Masquerade Account Name"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1098.007",
                "name": "Additional Local or Domain Groups"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1071.002",
                "name": "File Transfer Protocols"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1187",
                "name": "Forced Authentication"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0036",
        "name": "GCMAN",
        "fileName": "G0036-GCMAN.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0036) is a threat group that focuses on targeting banks for the purpose of transferring money to e-currency services. (Citation: Securelist GCMAN)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1021.005",
                "name": "VNC"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            }
        ]
    },
    {
        "id": "G0037",
        "name": "FIN6",
        "fileName": "G0037-FIN6.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0037) is a cyber crime group that has stolen payment card data and sold it for profit on underground marketplaces. This group has aggressively targeted and compromised point of sale (PoS) systems in the hospitality and retail sectors.(Citation: FireEye FIN6 April 2016)(Citation: FireEye FIN6 Apr 2019)",
        "aliases": [
            "Magecart Group 6",
            "ITG08",
            "Skeleton Spider",
            "TAAL",
            "Camouflage Tempest"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Retail"
        ],
        "techniques": [
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1213.006",
                "name": "Databases"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1134",
                "name": "Access Token Manipulation"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1110.002",
                "name": "Password Cracking"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1573.002",
                "name": "Asymmetric Cryptography"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            }
        ]
    },
    {
        "id": "G0038",
        "name": "Stealth Falcon",
        "fileName": "G0038-Stealth Falcon.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0038) is a threat group that has conducted targeted spyware attacks against Emirati journalists, activists, and dissidents since at least 2012. Circumstantial evidence suggests there could be a link between this group and the United Arab Emirates (UAE) government, but that has not been confirmed. (Citation: Citizen Lab Stealth Falcon May 2016)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1555.004",
                "name": "Windows Credential Manager"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            }
        ]
    },
    {
        "id": "G0039",
        "name": "Suckfly",
        "fileName": "G0039-Suckfly.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0039) is a China-based threat group that has been active since at least 2014. (Citation: Symantec Suckfly March 2016)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0040",
        "name": "Patchwork",
        "fileName": "G0040-Patchwork.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0040) is a cyber espionage group that was first observed in December 2015. While the group has not been definitively attributed, circumstantial evidence suggests the group may be a pro-Indian or Indian entity. (https://attack.mitre.org/groups/G0040) has been seen targeting industries related to diplomatic and government agencies. Much of the code used by this group was copied and pasted from online forums. (https://attack.mitre.org/groups/G0040) was also seen operating spearphishing campaigns targeting U.S. think tank groups in March and April of 2018.(Citation: Cymmetria Patchwork) (Citation: Symantec Patchwork)(Citation: TrendMicro Patchwork Dec 2017)(Citation: Volexity Patchwork June 2018)",
        "aliases": [
            "Hangover Group",
            "Dropping Elephant",
            "Chinastrats",
            "MONSOON",
            "Operation Hangover"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1197",
                "name": "BITS Jobs"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1587.002",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            }
        ]
    },
    {
        "id": "G0041",
        "name": "Strider",
        "fileName": "G0041-Strider.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0041) is a threat group that has been active since at least 2011 and has targeted victims in Russia, China, Sweden, Belgium, Iran, and Rwanda.(Citation: Symantec Strider Blog)(Citation: Kaspersky ProjectSauron Blog)",
        "aliases": [
            "ProjectSauron"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1556.002",
                "name": "Password Filter DLL"
            },
            {
                "id": "T1564.005",
                "name": "Hidden File System"
            }
        ]
    },
    {
        "id": "G0043",
        "name": "Group5",
        "fileName": "G0043-Group5.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0043) is a threat group with a suspected Iranian nexus, though this attribution is not definite. The group has targeted individuals connected to the Syrian opposition via spearphishing and watering holes, normally using Syrian and Iranian themes. (https://attack.mitre.org/groups/G0043) has used two commonly available remote access tools (RATs), (https://attack.mitre.org/software/S0385) and (https://attack.mitre.org/software/S0336), as well as an Android RAT, DroidJack. (Citation: Citizen Lab Group5)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            }
        ]
    },
    {
        "id": "G0044",
        "name": "Winnti Group",
        "fileName": "G0044-Winnti Group.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0044) is a threat group with Chinese origins that has been active since at least 2010. The group has heavily targeted the gaming industry, but it has also expanded the scope of its targeting.(Citation: Kaspersky Winnti April 2013)(Citation: Kaspersky Winnti June 2015)(Citation: Novetta Winnti April 2015) Some reporting suggests a number of other groups, including (https://attack.mitre.org/groups/G0001), (https://attack.mitre.org/groups/G0025), and (https://attack.mitre.org/groups/G0004), are closely linked to (https://attack.mitre.org/groups/G0044).(Citation: 401 TRG Winnti Umbrella May 2018)",
        "aliases": [
            "Blackfly"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1014",
                "name": "Rootkit"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            }
        ]
    },
    {
        "id": "G0045",
        "name": "menuPass",
        "fileName": "G0045-menuPass.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0045) is a threat group that has been active since at least 2006. Individual members of (https://attack.mitre.org/groups/G0045) are known to have acted in association with the Chinese Ministry of State Security's (MSS) Tianjin State Security Bureau and worked for the Huaying Haitai Science and Technology Development Company.(Citation: DOJ APT10 Dec 2018)(Citation: District Court of NY APT10 Indictment December 2018)",
        "aliases": [
            "Cicada",
            "POTASSIUM",
            "Stone Panda",
            "APT10",
            "Red Apollo",
            "CVNX",
            "HOGFISH",
            "BRONZE RIVERSIDE"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Healthcare",
            "Finance",
            "Energy",
            "Government",
            "Defense",
            "Aerospace",
            "Technology",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1568.001",
                "name": "Fast Flux DNS"
            },
            {
                "id": "T1036.003",
                "name": "Rename Legitimate Utilities"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1218.004",
                "name": "InstallUtil"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1070.003",
                "name": "Clear Command History"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0046",
        "name": "FIN7",
        "fileName": "G0046-FIN7.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0046) is a financially-motivated threat group that has been active since 2013. (https://attack.mitre.org/groups/G0046) has targeted the retail, restaurant, hospitality, software, consulting, financial services, medical equipment, cloud services, media, food and beverage, transportation, pharmaceutical, and utilities industries in the United States. A portion of (https://attack.mitre.org/groups/G0046) was operated out of a front company called Combi Security and often used point-of-sale malware for targeting efforts. Since 2020, (https://attack.mitre.org/groups/G0046) shifted operations to big game hunting (BGH), including use of (https://attack.mitre.org/software/S0496) ransomware and their own Ransomware-as-a-Service (RaaS), Darkside. FIN7 may be linked to the (https://attack.mitre.org/groups/G0008) Group, but multiple threat groups have been observed using (https://attack.mitre.org/software/S0030), leading these groups to be tracked separately.(Citation: FireEye FIN7 March 2017)(Citation: FireEye FIN7 April 2017)(Citation: FireEye CARBANAK June 2017)(Citation: FireEye FIN7 Aug 2018)(Citation: CrowdStrike Carbon Spider August 2021)(Citation: Mandiant FIN7 Apr 2022)(Citation: BiZone Lizar May 2021)",
        "aliases": [
            "GOLD NIAGARA",
            "ITG14",
            "Carbon Spider",
            "ELBRUS",
            "Sangria Tempest"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Financial",
            "Retail",
            "Media"
        ],
        "techniques": [
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1608.005",
                "name": "Link Target"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1021.005",
                "name": "VNC"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1620",
                "name": "Reflective Code Loading"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1546.011",
                "name": "Application Shimming"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1674",
                "name": "Input Injection"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1591",
                "name": "Gather Victim Org Information"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1497.002",
                "name": "User Activity Based Checks"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1608.004",
                "name": "Drive-by Target"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1125",
                "name": "Video Capture"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1591.004",
                "name": "Identify Roles"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1008",
                "name": "Fallback Channels"
            },
            {
                "id": "T1558.003",
                "name": "Kerberoasting"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0047",
        "name": "Gamaredon Group",
        "fileName": "G0047-Gamaredon Group.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0047) is a suspected Russian cyber espionage group that has targeted military, law enforcement, judiciary, non-profit, and non-governmental organizations in Ukraine since at least 2013. The name (https://attack.mitre.org/groups/G0047) derives from a misspelling of the word \"Armageddon,\" found in early campaigns.(Citation: Palo Alto Gamaredon Feb 2017)(Citation: TrendMicro Gamaredon April 2020)(Citation: ESET Gamaredon June 2020)(Citation: Symantec Shuckworm January 2022)(Citation: Microsoft Actinium February 2022)",
        "aliases": [
            "IRON TILDEN",
            "Primitive Bear",
            "ACTINIUM",
            "Armageddon",
            "Shuckworm",
            "DEV-0157",
            "Aqua Blizzard",
            "NastyShrew"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1491.001",
                "name": "Internal Defacement"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1001",
                "name": "Data Obfuscation"
            },
            {
                "id": "T1534",
                "name": "Internal Spearphishing"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1027.004",
                "name": "Compile After Delivery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1021.005",
                "name": "VNC"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1102.003",
                "name": "One-Way Communication"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1620",
                "name": "Reflective Code Loading"
            },
            {
                "id": "T1559.001",
                "name": "Component Object Model"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1025",
                "name": "Data from Removable Media"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1080",
                "name": "Taint Shared Content"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1561.001",
                "name": "Disk Content Wipe"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1587.003",
                "name": "Digital Certificates"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1027.012",
                "name": "LNK Icon Smuggling"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1020",
                "name": "Automated Exfiltration"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1568.001",
                "name": "Fast Flux DNS"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1568",
                "name": "Dynamic Resolution"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1480",
                "name": "Execution Guardrails"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1137",
                "name": "Office Application Startup"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1497.001",
                "name": "System Checks"
            }
        ]
    },
    {
        "id": "G0048",
        "name": "RTM",
        "fileName": "G0048-RTM.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0048) is a cybercriminal group that has been active since at least 2015 and is primarily interested in users of remote banking systems in Russia and neighboring countries. The group uses a Trojan by the same name ((https://attack.mitre.org/software/S0148)). (Citation: ESET RTM Feb 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            }
        ]
    },
    {
        "id": "G0049",
        "name": "OilRig",
        "fileName": "G0049-OilRig.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0049) is a suspected Iranian threat group that has targeted Middle Eastern and international victims since at least 2014. The group has targeted a variety of sectors, including financial, government, energy, chemical, and telecommunications. It appears the group carries out supply chain attacks, leveraging the trust relationship between organizations to attack their primary targets. The group works on behalf of the Iranian government based on infrastructure details that contain references to Iran, use of Iranian infrastructure, and targeting that aligns with nation-state interests.(Citation: FireEye APT34 Dec 2017)(Citation: Palo Alto OilRig April 2017)(Citation: ClearSky OilRig Jan 2017)(Citation: Palo Alto OilRig May 2016)(Citation: Palo Alto OilRig Oct 2016)(Citation: Unit42 OilRig Playbook 2023)(Citation: Unit 42 QUADAGENT July 2018)",
        "aliases": [
            "COBALT GYPSY",
            "IRN2",
            "APT34",
            "Helix Kitten",
            "Evasive Serpens",
            "Hazel Sandstorm",
            "EUROPIUM",
            "ITG13",
            "Earth Simnavaz",
            "Crambus",
            "TA452"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial",
            "Energy",
            "Government",
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1555.004",
                "name": "Windows Credential Manager"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1008",
                "name": "Fallback Channels"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1686.003",
                "name": "Windows Host Firewall"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1218.001",
                "name": "Compiled HTML File"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1137.004",
                "name": "Outlook Home Page"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1025",
                "name": "Data from Removable Media"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1556.002",
                "name": "Password Filter DLL"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1201",
                "name": "Password Policy Discovery"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1195",
                "name": "Supply Chain Compromise"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1573.002",
                "name": "Asymmetric Cryptography"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1115",
                "name": "Clipboard Data"
            },
            {
                "id": "T1003.005",
                "name": "Cached Domain Credentials"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1069.001",
                "name": "Local Groups"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1497.001",
                "name": "System Checks"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            }
        ]
    },
    {
        "id": "G0050",
        "name": "APT32",
        "fileName": "G0050-APT32.html",
        "severity": "high",
        "country": "Vietnam",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0050) is a suspected Vietnam-based threat group that has been active since at least 2014. The group has targeted multiple private sector industries as well as foreign governments, dissidents, and journalists with a strong focus on Southeast Asian countries like Vietnam, the Philippines, Laos, and Cambodia. They have extensively used strategic web compromises to compromise victims.(Citation: FireEye APT32 May 2017)(Citation: Volexity OceanLotus Nov 2017)(Citation: ESET OceanLotus)",
        "aliases": [
            "SeaLotus",
            "OceanLotus",
            "APT-C-00",
            "Canvas Cyclone",
            "BISMUTH"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1072",
                "name": "Software Deployment Tools"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1564.004",
                "name": "NTFS File Attributes"
            },
            {
                "id": "T1552.002",
                "name": "Credentials in Registry"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1216.001",
                "name": "PubPrn"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1608.004",
                "name": "Drive-by Target"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1589",
                "name": "Gather Victim Identity Information"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1071.003",
                "name": "Mail Protocols"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1027.011",
                "name": "Fileless Storage"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1036.003",
                "name": "Rename Legitimate Utilities"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1222.002",
                "name": "Linux and Mac Permissions"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1550.003",
                "name": "Pass the Ticket"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1137",
                "name": "Office Application Startup"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0051",
        "name": "FIN10",
        "fileName": "G0051-FIN10.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0051) is a financially motivated threat group that has targeted organizations in North America since at least 2013 through 2016. The group uses stolen data exfiltrated from victims to extort organizations. (Citation: FireEye FIN10 June 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            }
        ]
    },
    {
        "id": "G0052",
        "name": "CopyKittens",
        "fileName": "G0052-CopyKittens.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0052) is an Iranian cyber espionage group that has been operating since at least 2013. It has targeted countries including Israel, Saudi Arabia, Turkey, the U.S., Jordan, and Germany. The group is responsible for the campaign known as Operation Wilted Tulip.(Citation: ClearSky CopyKittens March 2017)(Citation: ClearSky Wilted Tulip July 2017)(Citation: CopyKittens Nov 2015)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            }
        ]
    },
    {
        "id": "G0053",
        "name": "FIN5",
        "fileName": "G0053-FIN5.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0053) is a financially motivated threat group that has targeted personally identifiable information and payment card information. The group has been active since at least 2008 and has targeted the restaurant, gaming, and hotel industries. The group is made up of actors who likely speak Russian. (Citation: FireEye Respond Webinar July 2017) (Citation: Mandiant FIN5 GrrCON Oct 2016) (Citation: DarkReading FireEye FIN5 Oct 2015)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            }
        ]
    },
    {
        "id": "G0054",
        "name": "Sowbug",
        "fileName": "G0054-Sowbug.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0054) is a threat group that has conducted targeted attacks against organizations in South America and Southeast Asia, particularly government entities, since at least 2015. (Citation: Symantec Sowbug Nov 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0055",
        "name": "NEODYMIUM",
        "fileName": "G0055-NEODYMIUM.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0055) is an activity group that conducted a campaign in May 2016 and has heavily targeted Turkish victims. The group has demonstrated similarity to another activity group called (https://attack.mitre.org/groups/G0056) due to overlapping victim and campaign characteristics. (Citation: Microsoft NEODYMIUM Dec 2016) (Citation: Microsoft SIR Vol 21) (https://attack.mitre.org/groups/G0055) is reportedly associated closely with (https://attack.mitre.org/groups/G0063) operations, but evidence that the group names are aliases has not been identified. (Citation: CyberScoop BlackOasis Oct 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0056",
        "name": "PROMETHIUM",
        "fileName": "G0056-PROMETHIUM.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0056) is an activity group focused on espionage that has been active since at least 2012. The group has conducted operations globally with a heavy emphasis on Turkish targets. (https://attack.mitre.org/groups/G0056) has demonstrated similarity to another activity group called (https://attack.mitre.org/groups/G0055) due to overlapping victim and campaign characteristics.(Citation: Microsoft NEODYMIUM Dec 2016)(Citation: Microsoft SIR Vol 21)(Citation: Talos Promethium June 2020)",
        "aliases": [
            "StrongPity"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1587.002",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1587.003",
                "name": "Digital Certificates"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1205.001",
                "name": "Port Knocking"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            }
        ]
    },
    {
        "id": "G0058",
        "name": "Charming Kitten",
        "fileName": "G0058-Charming Kitten.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0058) is an Iranian cyber espionage group that has been active since approximately 2014. They appear to focus on targeting individuals of interest to Iran who work in academic research, human rights, and media, with most victims having been located in Iran, the US, Israel, and the UK. (https://attack.mitre.org/groups/G0058) often tries to access private email and Facebook accounts, and sometimes establishes a foothold on victim computers as a secondary objective. The group's TTPs overlap extensively with another group, (https://attack.mitre.org/groups/G0059), resulting in reporting that may not distinguish between the two groups' activities.(Citation: ClearSky Charming Kitten Dec 2017)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Media"
        ],
        "techniques": []
    },
    {
        "id": "G0059",
        "name": "Magic Hound",
        "fileName": "G0059-Magic Hound.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0059) is an Iranian-sponsored threat group that conducts long term, resource-intensive cyber espionage operations, likely on behalf of the Islamic Revolutionary Guard Corps. They have targeted European, U.S., and Middle Eastern government and military personnel, academics, journalists, and organizations such as the World Health Organization (WHO), via complex social engineering campaigns since at least 2014.(Citation: FireEye APT35 2018)(Citation: ClearSky Kittens Back 3 August 2020)(Citation: Certfa Charming Kitten January 2021)(Citation: Secureworks COBALT ILLUSION Threat Profile)(Citation: Proofpoint TA453 July2021)",
        "aliases": [
            "TA453",
            "COBALT ILLUSION",
            "Charming Kitten",
            "ITG18",
            "Phosphorus",
            "Newscaster",
            "APT35",
            "Mint Sandstorm"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1567",
                "name": "Exfiltration Over Web Service"
            },
            {
                "id": "T1589.001",
                "name": "Credentials"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1016.002",
                "name": "Wi-Fi Discovery"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1584.001",
                "name": "Domains"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1591.001",
                "name": "Determine Physical Locations"
            },
            {
                "id": "T1071",
                "name": "Application Layer Protocol"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1592.002",
                "name": "Software"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1590.005",
                "name": "IP Addresses"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1573",
                "name": "Encrypted Channel"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1685.001",
                "name": "Disable or Modify Windows Event Log"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1036.010",
                "name": "Masquerade Account Name"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1098.002",
                "name": "Additional Email Delegate Permissions"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1078.001",
                "name": "Default Accounts"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1098.007",
                "name": "Additional Local or Domain Groups"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1114",
                "name": "Email Collection"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1686.003",
                "name": "Windows Host Firewall"
            },
            {
                "id": "T1070.003",
                "name": "Clear Command History"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1114.001",
                "name": "Local Email Collection"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1482",
                "name": "Domain Trust Discovery"
            },
            {
                "id": "T1589",
                "name": "Gather Victim Identity Information"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1087.003",
                "name": "Email Account"
            }
        ]
    },
    {
        "id": "G0060",
        "name": "BRONZE BUTLER",
        "fileName": "G0060-BRONZE BUTLER.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0060) is a cyber espionage group with likely Chinese origins that has been active since at least 2008. The group primarily targets Japanese organizations, particularly those in government, biotechnology, electronics manufacturing, and industrial chemistry.(Citation: Trend Micro Daserf Nov 2017)(Citation: Secureworks BRONZE BUTLER Oct 2017)(Citation: Trend Micro Tick November 2019)",
        "aliases": [
            "REDBALDKNIGHT",
            "Tick"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Technology",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1053.002",
                "name": "At"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1080",
                "name": "Taint Shared Content"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1550.003",
                "name": "Pass the Ticket"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1036.002",
                "name": "Right-to-Left Override"
            }
        ]
    },
    {
        "id": "G0061",
        "name": "FIN8",
        "fileName": "G0061-FIN8.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0061) is a financially motivated threat group that has been active since at least January 2016, and known for targeting organizations in the hospitality, retail, entertainment, insurance, technology, chemical, and financial sectors. In June 2021, security researchers detected (https://attack.mitre.org/groups/G0061) switching from targeting point-of-sale (POS) devices to distributing a number of ransomware variants.(Citation: FireEye Obfuscation June 2017)(Citation: FireEye Fin8 May 2016)(Citation: Bitdefender Sardonic Aug 2021)(Citation: Symantec FIN8 Jul 2023)",
        "aliases": [
            "Syssphinx"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Financial",
            "Technology",
            "Retail"
        ],
        "techniques": [
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1573.002",
                "name": "Asymmetric Cryptography"
            },
            {
                "id": "T1055.004",
                "name": "Asynchronous Procedure Call"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1482",
                "name": "Domain Trust Discovery"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1134.001",
                "name": "Token Impersonation/Theft"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            }
        ]
    },
    {
        "id": "G0062",
        "name": "TA459",
        "fileName": "G0062-TA459.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0062) is a threat group believed to operate out of China that has targeted countries including Russia, Belarus, Mongolia, and others. (Citation: Proofpoint TA459 April 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            }
        ]
    },
    {
        "id": "G0063",
        "name": "BlackOasis",
        "fileName": "G0063-BlackOasis.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0063) is a Middle Eastern threat group that is believed to be a customer of Gamma Group. The group has shown interest in prominent figures in the United Nations, as well as opposition bloggers, activists, regional news correspondents, and think tanks. (Citation: Securelist BlackOasis Oct 2017) (Citation: Securelist APT Trends Q2 2017) A group known by Microsoft as (https://attack.mitre.org/groups/G0055) is reportedly associated closely with (https://attack.mitre.org/groups/G0063) operations, but evidence that the group names are aliases has not been identified. (Citation: CyberScoop BlackOasis Oct 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            }
        ]
    },
    {
        "id": "G0064",
        "name": "APT33",
        "fileName": "G0064-APT33.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0064) is a suspected Iranian threat group that has carried out operations since at least 2013. The group has targeted organizations across multiple industries in the United States, Saudi Arabia, and South Korea, with a particular interest in the aviation and energy sectors.(Citation: FireEye APT33 Sept 2017)(Citation: FireEye APT33 Webinar Sept 2017)",
        "aliases": [
            "HOLMIUM",
            "Elfin",
            "Peach Sandstorm"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Energy"
        ],
        "techniques": [
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1003.005",
                "name": "Cached Domain Credentials"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1552.006",
                "name": "Group Policy Preferences"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1040",
                "name": "Network Sniffing"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1078.004",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            }
        ]
    },
    {
        "id": "G0065",
        "name": "Leviathan",
        "fileName": "G0065-Leviathan.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0065) is a Chinese state-sponsored cyber espionage group that has been attributed to the Ministry of State Security's (MSS) Hainan State Security Department and an affiliated front company.(Citation: CISA AA21-200A APT40 July 2021) Active since at least 2009, (https://attack.mitre.org/groups/G0065) has targeted the following sectors: academia, aerospace/aviation, biomedical, defense industrial base, government, healthcare, manufacturing, maritime, and transportation across the US, Canada, Australia, Europe, the Middle East, and Southeast Asia.(Citation: CISA AA21-200A APT40 July 2021)(Citation: Proofpoint Leviathan Oct 2017)(Citation: FireEye Periscope March 2018)(Citation: CISA Leviathan 2024)",
        "aliases": [
            "MUDCARP",
            "Kryptonite Panda",
            "Gadolinium",
            "BRONZE MOHAWK",
            "TEMP.Jumper",
            "APT40",
            "TEMP.Periscope",
            "Gingham Typhoon"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Healthcare",
            "Government",
            "Defense",
            "Aerospace",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1102.003",
                "name": "One-Way Communication"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1589.001",
                "name": "Credentials"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1586.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1547.009",
                "name": "Shortcut Modification"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1587.004",
                "name": "Exploits"
            },
            {
                "id": "T1197",
                "name": "BITS Jobs"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1534",
                "name": "Internal Spearphishing"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1584.008",
                "name": "Network Devices"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1560",
                "name": "Archive Collected Data"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0066",
        "name": "Elderwood",
        "fileName": "G0066-Elderwood.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0066) is a suspected Chinese cyber espionage group that was reportedly responsible for the 2009 Google intrusion known as Operation Aurora. (Citation: Security Affairs Elderwood Sept 2012) The group has targeted defense organizations, supply chain manufacturers, human rights and nongovernmental organizations (NGOs), and IT service providers. (Citation: Symantec Elderwood Sept 2012) (Citation: CSM Elderwood Sept 2012)",
        "aliases": [
            "Elderwood Gang",
            "Beijing Group",
            "Sneaky Panda"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            }
        ]
    },
    {
        "id": "G0067",
        "name": "APT37",
        "fileName": "G0067-APT37.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0067) is a North Korean state-sponsored cyber espionage group that has been active since at least 2012. The group has targeted victims primarily in South Korea, but also in Japan, Vietnam, Russia, Nepal, China, India, Romania, Kuwait, and other parts of the Middle East. (https://attack.mitre.org/groups/G0067) has also been linked to the following campaigns between 2016-2018: Operation Daybreak, Operation Erebus, Golden Time, Evil New Year, Are you Happy?, FreeMilk, North Korean Human Rights, and Evil New Year 2018.(Citation: FireEye APT37 Feb 2018)(Citation: Securelist ScarCruft Jun 2016)(Citation: Talos Group123)",
        "aliases": [
            "InkySquid",
            "ScarCruft",
            "Reaper",
            "Group123",
            "TEMP.Reaper",
            "Ricochet Chollima"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1036.001",
                "name": "Invalid Code Signature"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1529",
                "name": "System Shutdown/Reboot"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1123",
                "name": "Audio Capture"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1561.002",
                "name": "Disk Structure Wipe"
            }
        ]
    },
    {
        "id": "G0068",
        "name": "PLATINUM",
        "fileName": "G0068-PLATINUM.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0068) is an activity group that has targeted victims since at least 2009. The group has focused on targets associated with governments and related organizations in South and Southeast Asia. (Citation: Microsoft PLATINUM April 2016)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1056.004",
                "name": "Credential API Hooking"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            }
        ]
    },
    {
        "id": "G0069",
        "name": "MuddyWater",
        "fileName": "G0069-MuddyWater.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0069) is a cyber espionage group assessed to be a subordinate element within Iran's Ministry of Intelligence and Security (MOIS).(Citation: CYBERCOM Iranian Intel Cyber January 2022) Since at least 2017, (https://attack.mitre.org/groups/G0069) has targeted a range of government and private organizations across sectors, including telecommunications, local government, finance, defense, and oil and natural gas organizations, in the Middle East (specifically the UAE and Saudi Arabia), Asia, Africa, Europe, and North America. (https://attack.mitre.org/groups/G0069) has reused domains dating back to October 2025, and has a preference for NameCheap and Hosterdaddy Private Limited (AS136557). In late 2025 and early 2026, (https://attack.mitre.org/groups/G0069) used commercial satellite internet (i.e., Starlink) for command and control (C2) communication. (Citation: FalconFeeds_Iran_Mar2026)(Citation: Huntio_IranInfra_Mar2026)(Citation: Unit 42 MuddyWater Nov 2017)(Citation: Symantec MuddyWater Dec 2018)(Citation: ClearSky MuddyWater Nov 2018)(Citation: ClearSky MuddyWater June 2019)(Citation: Reaqta MuddyWater November 2017)(Citation: DHS CISA AA22-055A MuddyWater February 2022)(Citation: Talos MuddyWater Jan 2022)(Citation: NaumaanProofpoint_GlobalClickFix_April2025)(Citation: ESET_MuddyWater_Dec2025)(Citation: SymantecCarbonBlack_Seedworm_Mar2026)   ",
        "aliases": [
            "Earth Vetala",
            "MERCURY",
            "Static Kitten",
            "Seedworm",
            "TEMP.Zagros",
            "Mango Sandstorm",
            "TA450",
            "MuddyKrill"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Finance",
            "Government",
            "Defense",
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1137.001",
                "name": "Office Template Macros"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1204.004",
                "name": "Malicious Copy and Paste"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1534",
                "name": "Internal Spearphishing"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1590.004",
                "name": "Network Topology"
            },
            {
                "id": "T1559.001",
                "name": "Component Object Model"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1218.003",
                "name": "CMSTP"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1027.004",
                "name": "Compile After Delivery"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1566",
                "name": "Phishing"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1104",
                "name": "Multi-Stage Channels"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1003.005",
                "name": "Cached Domain Credentials"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0070",
        "name": "Dark Caracal",
        "fileName": "G0070-Dark Caracal.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0070) is threat group that has been attributed to the Lebanese General Directorate of General Security (GDGS) and has operated since at least 2012. (Citation: Lookout Dark Caracal Jan 2018)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1218.001",
                "name": "Compiled HTML File"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            }
        ]
    },
    {
        "id": "G0071",
        "name": "Orangeworm",
        "fileName": "G0071-Orangeworm.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0071) is a group that has targeted organizations in the healthcare sector in the United States, Europe, and Asia since at least 2015, likely for the purpose of corporate espionage.(Citation: Symantec Orangeworm April 2018) Reverse engineering of (https://attack.mitre.org/software/S0236), directly associated with (https://attack.mitre.org/groups/G0071) activity, indicates significant functional and development overlaps with (https://attack.mitre.org/software/S0140).(Citation: Cylera Kwampirs 2022)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Healthcare"
        ],
        "techniques": [
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            }
        ]
    },
    {
        "id": "G0072",
        "name": "Honeybee",
        "fileName": "G0072-Honeybee.html",
        "severity": "high",
        "country": "Vietnam",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0072) is a campaign led by an unknown actor that targets humanitarian aid organizations and has been active in Vietnam, Singapore, Argentina, Japan, Indonesia, and Canada. It has been an active operation since August of 2017 and as recently as February 2018. (Citation: McAfee Honeybee)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0073",
        "name": "APT19",
        "fileName": "G0073-APT19.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0073) is a Chinese-based threat group that has targeted a variety of industries, including defense, finance, energy, pharmaceutical, telecommunications, high tech, education, manufacturing, and legal services. In 2017, a phishing campaign was used to target seven law and investment firms. (Citation: FireEye APT19) Some analysts track (https://attack.mitre.org/groups/G0073) and (https://attack.mitre.org/groups/G0009) as the same group, but it is unclear from open source information if the groups are the same. (Citation: ICIT China's Espionage Jul 2016) (Citation: FireEye APT Groups) (Citation: Unit 42 C0d0so0 Jan 2016)",
        "aliases": [
            "Codoso",
            "C0d0so0",
            "Codoso Team",
            "Sunshop Group"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Finance",
            "Energy",
            "Defense",
            "Telecommunications",
            "Manufacturing",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            }
        ]
    },
    {
        "id": "G0074",
        "name": "Dragonfly 2.0",
        "fileName": "G0074-Dragonfly 2.0.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0074) is a suspected Russian group that has targeted government entities and multiple U.S. critical infrastructure sectors since at least December 2015. (Citation: US-CERT TA18-074A) (Citation: Symantec Dragonfly Sept 2017) There is debate over the extent of overlap between (https://attack.mitre.org/groups/G0074) and (https://attack.mitre.org/groups/G0035), but there is sufficient evidence to lead to these being tracked as two separate groups. (Citation: Fortune Dragonfly 2.0 Sept 2017)(Citation: Dragos DYMALLOY )",
        "aliases": [
            "IRON LIBERTY",
            "DYMALLOY",
            "Berserk Bear"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": []
    },
    {
        "id": "G0075",
        "name": "Rancor",
        "fileName": "G0075-Rancor.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0075) is a threat group that has led targeted campaigns against the South East Asia region. (https://attack.mitre.org/groups/G0075) uses politically-motivated lures to entice victims to open malicious documents. (Citation: Rancor Unit42 June 2018)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1218.007",
                "name": "Msiexec"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            }
        ]
    },
    {
        "id": "G0076",
        "name": "Thrip",
        "fileName": "G0076-Thrip.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0076) is an espionage group that has targeted satellite communications, telecoms, and defense contractor companies in the U.S. and Southeast Asia. The group uses custom malware as well as \"living off the land\" techniques. (Citation: Symantec Thrip June 2018)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            }
        ]
    },
    {
        "id": "G0077",
        "name": "Leafminer",
        "fileName": "G0077-Leafminer.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0077) is an Iranian threat group that has targeted government organizations and business entities in the Middle East since at least early 2017. (Citation: Symantec Leafminer July 2018)",
        "aliases": [
            "Raspite"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1003.005",
                "name": "Cached Domain Credentials"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1003.004",
                "name": "LSA Secrets"
            },
            {
                "id": "T1055.013",
                "name": "Process Doppelgänging"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            }
        ]
    },
    {
        "id": "G0078",
        "name": "Gorgon Group",
        "fileName": "G0078-Gorgon Group.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0078) is a threat group consisting of members who are suspected to be Pakistan-based or have other connections to Pakistan. The group has performed a mix of criminal and targeted attacks, including campaigns against government organizations in the United Kingdom, Spain, Russia, and the United States. (Citation: Unit 42 Gorgon Group Aug 2018)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1055.002",
                "name": "Portable Executable Injection"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1547.009",
                "name": "Shortcut Modification"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            }
        ]
    },
    {
        "id": "G0079",
        "name": "DarkHydrus",
        "fileName": "G0079-DarkHydrus.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0079) is a threat group that has targeted government agencies and educational institutions in the Middle East since at least 2016. The group heavily leverages open-source tools and custom payloads for carrying out attacks. (Citation: Unit 42 DarkHydrus July 2018) (Citation: Unit 42 Playbook Dec 2017)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1187",
                "name": "Forced Authentication"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            }
        ]
    },
    {
        "id": "G0080",
        "name": "Cobalt Group",
        "fileName": "G0080-Cobalt Group.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0080) is a financially motivated threat group that has primarily targeted financial institutions since at least 2016. The group has conducted intrusions to steal money via targeting ATM systems, card processing, payment systems and SWIFT systems. (https://attack.mitre.org/groups/G0080) has mainly targeted banks in Eastern Europe, Central Asia, and Southeast Asia. One of the alleged leaders was arrested in Spain in early 2018, but the group still appears to be active. The group has been known to target organizations in order to use their access to then compromise additional victims.(Citation: Talos Cobalt Group July 2018)(Citation: PTSecurity Cobalt Group Aug 2017)(Citation: PTSecurity Cobalt Dec 2016)(Citation: Group IB Cobalt Aug 2017)(Citation: Proofpoint Cobalt June 2017)(Citation: RiskIQ Cobalt Nov 2017)(Citation: RiskIQ Cobalt Jan 2018) Reporting indicates there may be links between (https://attack.mitre.org/groups/G0080) and both the malware (https://attack.mitre.org/software/S0030) and the group (https://attack.mitre.org/groups/G0008).(Citation: Europol Cobalt Mar 2018)",
        "aliases": [
            "GOLD KINGSWOOD",
            "Cobalt Gang",
            "Cobalt Spider"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1218.008",
                "name": "Odbcconf"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1218.003",
                "name": "CMSTP"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1220",
                "name": "XSL Script Processing"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1573.002",
                "name": "Asymmetric Cryptography"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1037.001",
                "name": "Logon Script (Windows)"
            }
        ]
    },
    {
        "id": "G0081",
        "name": "Tropic Trooper",
        "fileName": "G0081-Tropic Trooper.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0081) is an unaffiliated threat group that has led targeted campaigns against targets in Taiwan, the Philippines, and Hong Kong. (https://attack.mitre.org/groups/G0081) focuses on targeting government, healthcare, transportation, and high-tech industries and has been active since 2011.(Citation: TrendMicro Tropic Trooper Mar 2018)(Citation: Unit 42 Tropic Trooper Nov 2016)(Citation: TrendMicro Tropic Trooper May 2020)",
        "aliases": [
            "Pirate Panda",
            "KeyBoy"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Healthcare",
            "Government"
        ],
        "techniques": [
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1573",
                "name": "Encrypted Channel"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1052.001",
                "name": "Exfiltration over USB"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1573.002",
                "name": "Asymmetric Cryptography"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1547.004",
                "name": "Winlogon Helper DLL"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1020",
                "name": "Automated Exfiltration"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            }
        ]
    },
    {
        "id": "G0082",
        "name": "APT38",
        "fileName": "G0082-APT38.html",
        "severity": "high",
        "country": "North Korea",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0082) is a North Korean state-sponsored threat group that specializes in financial cyber operations; it has been attributed to the Reconnaissance General Bureau.(Citation: CISA AA20-239A BeagleBoyz August 2020) Active since at least 2014, (https://attack.mitre.org/groups/G0082) has targeted banks, financial institutions, casinos, cryptocurrency exchanges, SWIFT system endpoints, and ATMs in at least 38 countries worldwide. Significant operations include the 2016 Bank of Bangladesh heist, during which (https://attack.mitre.org/groups/G0082) stole $81 million, as well as attacks against Bancomext (Citation: FireEye APT38 Oct 2018) and Banco de Chile (Citation: FireEye APT38 Oct 2018); some of their attacks have been destructive.(Citation: CISA AA20-239A BeagleBoyz August 2020)(Citation: FireEye APT38 Oct 2018)(Citation: DOJ North Korea Indictment Feb 2021)(Citation: Kaspersky Lazarus Under The Hood Blog 2017)",
        "aliases": [
            "NICKEL GLADSTONE",
            "BeagleBoyz",
            "Bluenoroff",
            "Stardust Chollima",
            "Sapphire Sleet",
            "COPERNICIUM"
        ],
        "objectives": [
            "Destructive"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1529",
                "name": "System Shutdown/Reboot"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1217",
                "name": "Browser Information Discovery"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1485",
                "name": "Data Destruction"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1553.005",
                "name": "Mark-of-the-Web Bypass"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1565.002",
                "name": "Transmitted Data Manipulation"
            },
            {
                "id": "T1686.002",
                "name": "Network Device Firewall"
            },
            {
                "id": "T1561.002",
                "name": "Disk Structure Wipe"
            },
            {
                "id": "T1036.003",
                "name": "Rename Legitimate Utilities"
            },
            {
                "id": "T1690",
                "name": "Prevent Command History Logging"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1115",
                "name": "Clipboard Data"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1565.003",
                "name": "Runtime Data Manipulation"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1218.001",
                "name": "Compiled HTML File"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1565.001",
                "name": "Stored Data Manipulation"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1053.003",
                "name": "Cron"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1218.007",
                "name": "Msiexec"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1480.002",
                "name": "Mutual Exclusion"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1036.006",
                "name": "Space after Filename"
            }
        ]
    },
    {
        "id": "G0083",
        "name": "SilverTerrier",
        "fileName": "G0083-SilverTerrier.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0083) is a Nigerian threat group that has been seen active since 2014. (https://attack.mitre.org/groups/G0083) mainly targets organizations in high technology, higher education, and manufacturing.(Citation: Unit42 SilverTerrier 2018)(Citation: Unit42 SilverTerrier 2016)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Technology",
            "Manufacturing",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1071.003",
                "name": "Mail Protocols"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1071.002",
                "name": "File Transfer Protocols"
            },
            {
                "id": "T1657",
                "name": "Financial Theft"
            }
        ]
    },
    {
        "id": "G0084",
        "name": "Gallmaker",
        "fileName": "G0084-Gallmaker.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0084) is a cyberespionage group that has targeted victims in the Middle East and has been active since at least December 2017. The group has mainly targeted victims in the defense, military, and government sectors.(Citation: Symantec Gallmaker Oct 2018)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            }
        ]
    },
    {
        "id": "G0085",
        "name": "FIN4",
        "fileName": "G0085-FIN4.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0085) is a financially-motivated threat group that has targeted confidential information related to the public financial market, particularly regarding healthcare and pharmaceutical companies, since at least 2013.(Citation: FireEye Hacking FIN4 Dec 2014)(Citation: FireEye FIN4 Stealing Insider NOV 2014) (https://attack.mitre.org/groups/G0085) is unique in that they do not infect victims with typical persistent malware, but rather they focus on capturing credentials authorized to access email and other non-public correspondence.(Citation: FireEye Hacking FIN4 Dec 2014)(Citation: FireEye Hacking FIN4 Video Dec 2014)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Healthcare",
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1056.002",
                "name": "GUI Input Capture"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1564.008",
                "name": "Email Hiding Rules"
            }
        ]
    },
    {
        "id": "G0087",
        "name": "APT39",
        "fileName": "G0087-APT39.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0087) is one of several names for cyber espionage activity conducted by the Iranian Ministry of Intelligence and Security (MOIS) through the front company Rana Intelligence Computing since at least 2014. (https://attack.mitre.org/groups/G0087) has primarily targeted the travel, hospitality, academic, and telecommunications industries in Iran and across Asia, Africa, Europe, and North America to track individuals and entities considered to be a threat by the MOIS.(Citation: FireEye APT39 Jan 2019)(Citation: Symantec Chafer Dec 2015)(Citation: FBI FLASH APT39 September 2020)(Citation: Dept. of Treasury Iran Sanctions September 2020)(Citation: DOJ Iran Indictments September 2020)",
        "aliases": [
            "ITG07",
            "Chafer",
            "Remix Kitten"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1115",
                "name": "Clipboard Data"
            },
            {
                "id": "T1553.006",
                "name": "Code Signing Policy Modification"
            },
            {
                "id": "T1546.010",
                "name": "AppInit DLLs"
            },
            {
                "id": "T1547.009",
                "name": "Shortcut Modification"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1059.010",
                "name": "AutoHotKey & AutoIT"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1197",
                "name": "BITS Jobs"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1056",
                "name": "Input Capture"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0088",
        "name": "TEMP.Veles",
        "fileName": "G0088-TEMP.Veles.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0088) is a Russia-based threat group that has targeted critical infrastructure. The group has been observed utilizing (https://attack.mitre.org/software/S0609), a malware framework designed to manipulate industrial safety systems.(Citation: FireEye TRITON 2019)(Citation: FireEye TEMP.Veles 2018)(Citation: FireEye TEMP.Veles JSON April 2019)",
        "aliases": [
            "XENOTIME"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0089",
        "name": "The White Company",
        "fileName": "G0089-The White Company.html",
        "severity": "high",
        "country": "Pakistan",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0089) is a likely state-sponsored threat actor with advanced capabilities. From 2017 through 2018, the group led an espionage campaign called Operation Shaheen targeting government and military organizations in Pakistan.(Citation: Cylance Shaheen Nov 2018)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            }
        ]
    },
    {
        "id": "G0090",
        "name": "WIRTE",
        "fileName": "G0090-WIRTE.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0090) is a cyberespionage actor, believed to be a subgroup of the Hamas-affiliated Gaza Cybergang, that has been active since at least August 2018. (https://attack.mitre.org/groups/G0090) has targeted diplomatic, financial, military, legal, and technology organizations across the Middle East, North Africa, and in Europe to gather intelligence. (https://attack.mitre.org/groups/G0090) has remained persistently active despite the ongoing Israel-Hamas conflict and has expanded their operations to include wiper malware attacks against Israeli targets.(Citation: Lab52 WIRTE Apr 2019)(Citation: Kaspersky WIRTE November 2021)(Citation: Check Point Wirte NOV 2024)(Citation: Palo Alto Ashen Lepus DEC 2025)",
        "aliases": [
            "Ashen Lepus"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial",
            "Technology"
        ],
        "techniques": [
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1114.001",
                "name": "Local Email Collection"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1497.001",
                "name": "System Checks"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            }
        ]
    },
    {
        "id": "G0091",
        "name": "Silence",
        "fileName": "G0091-Silence.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0091) is a financially motivated threat actor targeting financial institutions in different countries. The group was first seen in June 2016. Their main targets reside in Russia, Ukraine, Belarus, Azerbaijan, Poland and Kazakhstan. They compromised various banking systems, including the Russian Central Bank's Automated Workstation Client, ATMs, and card processing.(Citation: Cyber Forensicator Silence Jan 2019)(Citation: SecureList Silence Nov 2017) ",
        "aliases": [
            "Whisper Spider"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1125",
                "name": "Video Capture"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1218.001",
                "name": "Compiled HTML File"
            },
            {
                "id": "T1072",
                "name": "Software Deployment Tools"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1106",
                "name": "Native API"
            }
        ]
    },
    {
        "id": "G0092",
        "name": "TA505",
        "fileName": "G0092-TA505.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0092) is a cyber criminal group that has been active since at least 2014. (https://attack.mitre.org/groups/G0092) is known for frequently changing malware, driving global trends in criminal malware distribution, and ransomware campaigns involving (https://attack.mitre.org/software/S0611).(Citation: Proofpoint TA505 Sep 2017)(Citation: Proofpoint TA505 June 2018)(Citation: Proofpoint TA505 Jan 2019)(Citation: NCC Group TA505)(Citation: Korean FSI TA505 2020)",
        "aliases": [
            "Hive0065",
            "Spandex Tempest",
            "CHIMBORAZO"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1553.005",
                "name": "Mark-of-the-Web Bypass"
            },
            {
                "id": "T1218.007",
                "name": "Msiexec"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1568.001",
                "name": "Fast Flux DNS"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1069",
                "name": "Permission Groups Discovery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1087.003",
                "name": "Email Account"
            }
        ]
    },
    {
        "id": "G0093",
        "name": "GALLIUM",
        "fileName": "G0093-GALLIUM.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0093) is a cyberespionage group that has been active since at least 2012, primarily targeting telecommunications companies, financial institutions, and government entities in Afghanistan, Australia, Belgium, Cambodia, Malaysia, Mozambique, the Philippines, Russia, and Vietnam. This group is particularly known for launching Operation Soft Cell, a long-term campaign targeting telecommunications providers.(Citation: Cybereason Soft Cell June 2019) Security researchers have identified (https://attack.mitre.org/groups/G0093) as a likely Chinese state-sponsored group, based in part on tools used and TTPs commonly associated with Chinese threat actors.(Citation: Cybereason Soft Cell June 2019)(Citation: Microsoft GALLIUM December 2019)(Citation: Unit 42 PingPull Jun 2022)",
        "aliases": [
            "Granite Typhoon"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial",
            "Government",
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1136.002",
                "name": "Domain Account"
            },
            {
                "id": "T1583.004",
                "name": "Server"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1027.005",
                "name": "Indicator Removal from Tools"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1036.003",
                "name": "Rename Legitimate Utilities"
            }
        ]
    },
    {
        "id": "G0094",
        "name": "Kimsuky",
        "fileName": "G0094-Kimsuky.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0094) is a Democratic People's Republic of Korea (DPRK)-based cyber espionage group that has been active since at least 2012. The group initially targeted South Korean government agencies, think tanks, and subject-matter experts in various fields. Its operations expanded to include the United Nations and organizations in the government, education, business services, and manufacturing sectors across the United States, Japan, Russia, and Europe. (https://attack.mitre.org/groups/G0094) has focused collection on foreign policy and national security issues tied to the Korean Peninsula, nuclear policy, and sanctions. (https://attack.mitre.org/groups/G0094) operations have overlapped with those of other North Korean state-sponsored cyber espionage actors as a result of ad hoc collaborations or other limited resource sharing.(Citation: EST Kimsuky April 2019)(Citation: Cybereason Kimsuky November 2020)(Citation: Malwarebytes Kimsuky June 2021)(Citation: CISA AA20-301A Kimsuky)(Citation: Mandiant APT43 March 2024)(Citation: Proofpoint TA427 April 2024) ",
        "aliases": [
            "Black Banshee",
            "Velvet Chollima",
            "Emerald Sleet",
            "THALLIUM",
            "APT43",
            "TA427",
            "Springtail",
            "Earth Kumiho",
            "PatheticSlug"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Manufacturing",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1678",
                "name": "Delay Execution"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1583",
                "name": "Acquire Infrastructure"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1566",
                "name": "Phishing"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1040",
                "name": "Network Sniffing"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1056.003",
                "name": "Web Portal Capture"
            },
            {
                "id": "T1539",
                "name": "Steal Web Session Cookie"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1020",
                "name": "Automated Exfiltration"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1204.004",
                "name": "Malicious Copy and Paste"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1587",
                "name": "Develop Capabilities"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1598",
                "name": "Phishing for Information"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1115",
                "name": "Clipboard Data"
            },
            {
                "id": "T1559.001",
                "name": "Component Object Model"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            },
            {
                "id": "T1489",
                "name": "Service Stop"
            },
            {
                "id": "T1217",
                "name": "Browser Information Discovery"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1534",
                "name": "Internal Spearphishing"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1593.001",
                "name": "Social Media"
            },
            {
                "id": "T1027.007",
                "name": "Dynamic API Resolution"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1585",
                "name": "Establish Accounts"
            },
            {
                "id": "T1589.003",
                "name": "Employee Names"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1564.002",
                "name": "Hidden Users"
            },
            {
                "id": "T1176.001",
                "name": "Browser Extensions"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1583.004",
                "name": "Server"
            },
            {
                "id": "T1552.004",
                "name": "Private Keys"
            },
            {
                "id": "T1620",
                "name": "Reflective Code Loading"
            },
            {
                "id": "T1111",
                "name": "Multi-Factor Authentication Interception"
            },
            {
                "id": "T1594",
                "name": "Search Victim-Owned Websites"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1591",
                "name": "Gather Victim Org Information"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1657",
                "name": "Financial Theft"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1568",
                "name": "Dynamic Resolution"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1027.012",
                "name": "LNK Icon Smuggling"
            },
            {
                "id": "T1596",
                "name": "Search Open Technical Databases"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1557",
                "name": "Adversary-in-the-Middle"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1185",
                "name": "Browser Session Hijacking"
            },
            {
                "id": "T1564.011",
                "name": "Ignore Process Interrupts"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1584.001",
                "name": "Domains"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1497.001",
                "name": "System Checks"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1071.003",
                "name": "Mail Protocols"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1546.001",
                "name": "Change Default File Association"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1588.005",
                "name": "Exploits"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1682",
                "name": "Query Public AI Services"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1480.002",
                "name": "Mutual Exclusion"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1132.002",
                "name": "Non-Standard Encoding"
            },
            {
                "id": "T1036.007",
                "name": "Double File Extension"
            },
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1114.003",
                "name": "Email Forwarding Rule"
            },
            {
                "id": "T1071.002",
                "name": "File Transfer Protocols"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1205",
                "name": "Traffic Signaling"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1098.007",
                "name": "Additional Local or Domain Groups"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1593.002",
                "name": "Search Engines"
            }
        ]
    },
    {
        "id": "G0095",
        "name": "Machete",
        "fileName": "G0095-Machete.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0095) is a suspected Spanish-speaking cyber espionage group that has been active since at least 2010. It has primarily focused its operations within Latin America, with a particular emphasis on Venezuela, but also in the US, Europe, Russia, and parts of Asia. (https://attack.mitre.org/groups/G0095) generally targets high-profile organizations such as government institutions, intelligence services, and military units, as well as telecommunications and power companies.(Citation: Cylance Machete Mar 2017)(Citation: Securelist Machete Aug 2014)(Citation: ESET Machete July 2019)(Citation: 360 Machete Sep 2020)",
        "aliases": [
            "APT-C-43",
            "El Machete"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government",
            "Telecommunications"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1218.007",
                "name": "Msiexec"
            }
        ]
    },
    {
        "id": "G0096",
        "name": "APT41",
        "fileName": "G0096-APT41.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0096) is a threat group that researchers have assessed as Chinese state-sponsored espionage group that also conducts financially-motivated operations. Active since at least 2012, (https://attack.mitre.org/groups/G0096) has been observed targeting various industries, including but not limited to healthcare, telecom, technology, finance, education, retail and video game industries in 14 countries.(Citation: apt41_mandiant) Notable behaviors include using a wide range of malware and tools to complete mission objectives. (https://attack.mitre.org/groups/G0096) overlaps at least partially with public reporting on groups including BARIUM and (https://attack.mitre.org/groups/G0044).(Citation: FireEye APT41 Aug 2019)(Citation: Group IB APT 41 June 2021)",
        "aliases": [
            "Wicked Panda",
            "Brass Typhoon",
            "BARIUM"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Healthcare",
            "Financial",
            "Finance",
            "Technology",
            "Retail",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1069",
                "name": "Permission Groups Discovery"
            },
            {
                "id": "T1595.003",
                "name": "Wordlist Scanning"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1014",
                "name": "Rootkit"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1071.002",
                "name": "File Transfer Protocols"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1596.005",
                "name": "Scan Databases"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1098.007",
                "name": "Additional Local or Domain Groups"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1037",
                "name": "Boot or Logon Initialization Scripts"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1542.003",
                "name": "Bootkit"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1599",
                "name": "Network Boundary Bridging"
            },
            {
                "id": "T1480.001",
                "name": "Environmental Keying"
            },
            {
                "id": "T1484.001",
                "name": "Group Policy Modification"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1574.006",
                "name": "Dynamic Linker Hijacking"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1568.002",
                "name": "Domain Generation Algorithms"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            },
            {
                "id": "T1008",
                "name": "Fallback Channels"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1496.001",
                "name": "Compute Hijacking"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1059.004",
                "name": "Unix Shell"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1218.001",
                "name": "Compiled HTML File"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1213.003",
                "name": "Code Repositories"
            },
            {
                "id": "T1197",
                "name": "BITS Jobs"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1104",
                "name": "Multi-Stage Channels"
            },
            {
                "id": "T1030",
                "name": "Data Transfer Size Limits"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1070.003",
                "name": "Clear Command History"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            }
        ]
    },
    {
        "id": "G0098",
        "name": "BlackTech",
        "fileName": "G0098-BlackTech.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0098) is a suspected Chinese cyber espionage group that has primarily targeted organizations in East Asia--particularly Taiwan, Japan, and Hong Kong--and the US since at least 2013. (https://attack.mitre.org/groups/G0098) has used a combination of custom malware, dual-use tools, and living off the land tactics to compromise media, construction, engineering, electronics, and financial company networks.(Citation: TrendMicro BlackTech June 2017)(Citation: Symantec Palmerworm Sep 2020)(Citation: Reuters Taiwan BlackTech August 2020)",
        "aliases": [
            "Palmerworm"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial",
            "Media"
        ],
        "techniques": [
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036.002",
                "name": "Right-to-Left Override"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1588.004",
                "name": "Digital Certificates"
            }
        ]
    },
    {
        "id": "G0099",
        "name": "APT-C-36",
        "fileName": "G0099-APT-C-36.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0099) is a suspected South American threat group that has engaged in espionage and financially motivated operations since at least 2018. (https://attack.mitre.org/groups/G0099) has targeted government institutions and entities in the financial, energy, and professional manufacturing sectors across Colombia and other Latin American countries.(Citation: QiAnXin APT-C-36 Feb2019)(Citation: Kaspersky BlindEagle AUG 2024)(Citation: Check Point Blind Eagle MAR 2025)(Citation: Recorded Future TAG-144 AUG 2025)",
        "aliases": [
            "Blind Eagle",
            "TAG-144",
            "AguilaCiega",
            "APT-Q-98"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial",
            "Energy",
            "Government",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1683.001",
                "name": "Written Content"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1684.001",
                "name": "Impersonation"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1584.005",
                "name": "Botnet"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1534",
                "name": "Internal Spearphishing"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1683.002",
                "name": "Audio-Visual Content"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1480",
                "name": "Execution Guardrails"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1568",
                "name": "Dynamic Resolution"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1586.003",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1593",
                "name": "Search Open Websites/Domains"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1055.012",
                "name": "Process Hollowing"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            }
        ]
    },
    {
        "id": "G0100",
        "name": "Inception",
        "fileName": "G0100-Inception.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0100) is a cyber espionage group active since at least 2014. The group has targeted multiple industries and governmental entities primarily in Russia, but has also been active in the United States and throughout Europe, Asia, Africa, and the Middle East.(Citation: Unit 42 Inception November 2018)(Citation: Symantec Inception Framework March 2018)(Citation: Kaspersky Cloud Atlas December 2014)",
        "aliases": [
            "Inception Framework",
            "Cloud Atlas"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1221",
                "name": "Template Injection"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            }
        ]
    },
    {
        "id": "G0101",
        "name": "Frankenstein",
        "fileName": "G0101-Frankenstein.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0101) is a campaign carried out between January and April 2019 by unknown threat actors. The campaign name comes from the actors' ability to piece together several unrelated components.(Citation: Talos Frankenstein June 2019)  ",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": []
    },
    {
        "id": "G0102",
        "name": "Wizard Spider",
        "fileName": "G0102-Wizard Spider.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0102) is a Russia-based financially motivated threat group originally known for the creation and deployment of (https://attack.mitre.org/software/S0266) since at least 2016. (https://attack.mitre.org/groups/G0102) possesses a diverse arsenal of tools and has conducted ransomware campaigns against a variety of organizations, ranging from major corporations to hospitals.(Citation: CrowdStrike Ryuk January 2019)(Citation: DHS/CISA Ransomware Targeting Healthcare October 2020)(Citation: CrowdStrike Wizard Spider October 2020)",
        "aliases": [
            "UNC1878",
            "TEMP.MixMaster",
            "Grim Spider",
            "FIN12",
            "GOLD BLACKBURN",
            "ITG23",
            "Periwinkle Tempest",
            "DEV-0193",
            "Pistachio Tempest",
            "DEV-0237"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Healthcare",
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1074",
                "name": "Data Staged"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1055",
                "name": "Process Injection"
            },
            {
                "id": "T1021",
                "name": "Remote Services"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1222.001",
                "name": "Windows Permissions"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1552.006",
                "name": "Group Policy Preferences"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1558.003",
                "name": "Kerberoasting"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1490",
                "name": "Inhibit System Recovery"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1547.004",
                "name": "Winlogon Helper DLL"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1518.002",
                "name": "Backup Software Discovery"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1136.002",
                "name": "Domain Account"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1557.001",
                "name": "Name Resolution Poisoning and SMB Relay"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1003.002",
                "name": "Security Account Manager"
            },
            {
                "id": "T1489",
                "name": "Service Stop"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1555.004",
                "name": "Windows Credential Manager"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1021.006",
                "name": "Windows Remote Management"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1197",
                "name": "BITS Jobs"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0103",
        "name": "Mofang",
        "fileName": "G0103-Mofang.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0103) is a likely China-based cyber espionage group, named for its frequent practice of imitating a victim's infrastructure. This adversary has been observed since at least May 2012 conducting focused attacks against government and critical infrastructure in Myanmar, as well as several other countries and sectors including military, automobile, and weapons industries.(Citation: FOX-IT May 2016 Mofang)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            }
        ]
    },
    {
        "id": "G0104",
        "name": "Sharpshooter",
        "fileName": "G0104-Sharpshooter.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "Operation (https://attack.mitre.org/groups/G0104) is the name of a cyber espionage campaign discovered in October 2018 targeting nuclear, defense, energy, and financial companies. Though overlaps between this adversary and (https://attack.mitre.org/groups/G0032) have been noted, definitive links have not been established.(Citation: McAfee Sharpshooter December 2018)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial",
            "Energy",
            "Defense"
        ],
        "techniques": []
    },
    {
        "id": "G0105",
        "name": "DarkVishnya",
        "fileName": "G0105-DarkVishnya.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0105) is a financially motivated threat actor targeting financial institutions in Eastern Europe. In 2017-2018 the group attacked at least 8 banks in this region.(Citation: Securelist DarkVishnya Dec 2018)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1200",
                "name": "Hardware Additions"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1040",
                "name": "Network Sniffing"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            }
        ]
    },
    {
        "id": "G0106",
        "name": "Rocke",
        "fileName": "G0106-Rocke.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0106) is an alleged Chinese-speaking adversary whose primary objective appeared to be cryptojacking, or stealing victim system resources for the purposes of mining cryptocurrency. The name (https://attack.mitre.org/groups/G0106) comes from the email address \"rocke@live.cn\" used to create the wallet which held collected cryptocurrency. Researchers have detected overlaps between (https://attack.mitre.org/groups/G0106) and the Iron Cybercrime Group, though this attribution has not been confirmed.(Citation: Talos Rocke August 2018)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1014",
                "name": "Rootkit"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1059.004",
                "name": "Unix Shell"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1071",
                "name": "Application Layer Protocol"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1496.001",
                "name": "Compute Hijacking"
            },
            {
                "id": "T1027.004",
                "name": "Compile After Delivery"
            },
            {
                "id": "T1574.006",
                "name": "Dynamic Linker Hijacking"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1053.003",
                "name": "Cron"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1055.002",
                "name": "Portable Executable Injection"
            },
            {
                "id": "T1102.001",
                "name": "Dead Drop Resolver"
            },
            {
                "id": "T1037",
                "name": "Boot or Logon Initialization Scripts"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1222.002",
                "name": "Linux and Mac Permissions"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1543.002",
                "name": "Systemd Service"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1685.006",
                "name": "Clear Linux or Mac System Logs"
            },
            {
                "id": "T1552.004",
                "name": "Private Keys"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1571",
                "name": "Non-Standard Port"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            }
        ]
    },
    {
        "id": "G0107",
        "name": "Whitefly",
        "fileName": "G0107-Whitefly.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0107) is a cyber espionage group that has been operating since at least 2017. The group has targeted organizations based mostly in Singapore across a wide variety of sectors, and is primarily interested in stealing large amounts of sensitive information. The group has been linked to an attack against Singapore’s largest public health organization, SingHealth.(Citation: Symantec Whitefly March 2019)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            }
        ]
    },
    {
        "id": "G0108",
        "name": "Blue Mockingbird",
        "fileName": "G0108-Blue Mockingbird.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0108) is a cluster of observed activity involving Monero cryptocurrency-mining payloads in dynamic-link library (DLL) form on Windows systems. The earliest observed Blue Mockingbird tools were created in December 2019.(Citation: RedCanary Mockingbird May 2020)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1574.012",
                "name": "COR_PROFILER"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1134",
                "name": "Access Token Manipulation"
            },
            {
                "id": "T1496.001",
                "name": "Compute Hijacking"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            }
        ]
    },
    {
        "id": "G0112",
        "name": "Windshift",
        "fileName": "G0112-Windshift.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0112) is a threat group that has been active since at least 2017, targeting specific individuals for surveillance in government departments and critical infrastructure across the Middle East.(Citation: SANS Windshift August 2018)(Citation: objective-see windtail1 dec 2018)(Citation: objective-see windtail2 jan 2019)",
        "aliases": [
            "Bahamut"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1036.001",
                "name": "Invalid Code Signature"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            }
        ]
    },
    {
        "id": "G0114",
        "name": "Chimera",
        "fileName": "G0114-Chimera.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0114) is a suspected China-based threat group that has been active since at least 2018 targeting the semiconductor industry in Taiwan as well as data from the airline industry.(Citation: Cycraft Chimera April 2020)(Citation: NCC Group Chimera January 2021)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1074.002",
                "name": "Remote Data Staging"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1569.002",
                "name": "Service Execution"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1550.002",
                "name": "Pass the Hash"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1556.001",
                "name": "Domain Controller Authentication"
            },
            {
                "id": "T1071.004",
                "name": "DNS"
            },
            {
                "id": "T1482",
                "name": "Domain Trust Discovery"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1021.006",
                "name": "Windows Remote Management"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1213.002",
                "name": "Sharepoint"
            },
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1570",
                "name": "Lateral Tool Transfer"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1069.001",
                "name": "Local Groups"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1201",
                "name": "Password Policy Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1114.001",
                "name": "Local Email Collection"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1110.004",
                "name": "Credential Stuffing"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1589.001",
                "name": "Credentials"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1111",
                "name": "Multi-Factor Authentication Interception"
            },
            {
                "id": "T1217",
                "name": "Browser Information Discovery"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            }
        ]
    },
    {
        "id": "G0115",
        "name": "GOLD SOUTHFIELD",
        "fileName": "G0115-GOLD SOUTHFIELD.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0115) is a financially motivated threat group active since at least 2018 that operates the (https://attack.mitre.org/software/S0496) Ransomware-as-a Service (RaaS). (https://attack.mitre.org/groups/G0115) provides backend infrastructure for affiliates recruited on underground forums to perpetrate high value deployments. By early 2020, (https://attack.mitre.org/groups/G0115) started capitalizing on the new trend of stealing data and further extorting the victim to pay for their data to not get publicly leaked.(Citation: Secureworks REvil September 2019)(Citation: Secureworks GandCrab and REvil September 2019)(Citation: Secureworks GOLD SOUTHFIELD)(Citation: CrowdStrike Evolution of Pinchy Spider July 2021)",
        "aliases": [
            "Pinchy Spider"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1113",
                "name": "Screen Capture"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1195.002",
                "name": "Compromise Software Supply Chain"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1566",
                "name": "Phishing"
            }
        ]
    },
    {
        "id": "G0116",
        "name": "Operation Wocao",
        "fileName": "G0116-Operation Wocao.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0116) described activities carried out by a China-based cyber espionage adversary. (https://attack.mitre.org/groups/G0116) targeted entities within the government, managed service providers, energy, health care, and technology sectors across several countries, including China, France, Germany, the United Kingdom, and the United States. (https://attack.mitre.org/groups/G0116) used similar TTPs and tools to APT20, suggesting a possible overlap.(Citation: FoxIT Wocao December 2019)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Energy",
            "Government",
            "Technology"
        ],
        "techniques": []
    },
    {
        "id": "G0117",
        "name": "Fox Kitten",
        "fileName": "G0117-Fox Kitten.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0117) is threat actor with a suspected nexus to the Iranian government that has been active since at least 2017 against entities in the Middle East, North Africa, Europe, Australia, and North America. (https://attack.mitre.org/groups/G0117) has targeted multiple industrial verticals including oil and gas, technology, government, defense, healthcare, manufacturing, and engineering.(Citation: ClearkSky Fox Kitten February 2020)(Citation: CrowdStrike PIONEER KITTEN August 2020)(Citation: Dragos PARISITE )(Citation: ClearSky Pay2Kitten December 2020)",
        "aliases": [
            "UNC757",
            "Parisite",
            "Pioneer Kitten",
            "RUBIDIUM",
            "Lemon Sandstorm"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Healthcare",
            "Government",
            "Defense",
            "Technology",
            "Manufacturing"
        ],
        "techniques": [
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1530",
                "name": "Data from Cloud Storage"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1110",
                "name": "Brute Force"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1585",
                "name": "Establish Accounts"
            },
            {
                "id": "T1021.005",
                "name": "VNC"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1217",
                "name": "Browser Information Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1213.005",
                "name": "Messaging Applications"
            },
            {
                "id": "T1021.002",
                "name": "SMB/Windows Admin Shares"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1555.005",
                "name": "Password Managers"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1087.001",
                "name": "Local Account"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1039",
                "name": "Data from Network Shared Drive"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1546.008",
                "name": "Accessibility Features"
            },
            {
                "id": "T1585.001",
                "name": "Social Media Accounts"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            }
        ]
    },
    {
        "id": "G0119",
        "name": "Indrik Spider",
        "fileName": "G0119-Indrik Spider.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0119) is a Russia-based cybercriminal group that has been active since at least 2014. (https://attack.mitre.org/groups/G0119) initially started with the (https://attack.mitre.org/software/S0384) banking Trojan, and then by 2017 they began running ransomware operations using (https://attack.mitre.org/software/S0570), (https://attack.mitre.org/software/S0612), and Hades ransomware. Following U.S. sanctions and an indictment in 2019, (https://attack.mitre.org/groups/G0119) changed their tactics and diversified their toolset.(Citation: Crowdstrike Indrik November 2018)(Citation: Crowdstrike EvilCorp March 2021)(Citation: Treasury EvilCorp Dec 2019)",
        "aliases": [
            "Evil Corp",
            "Manatee Tempest",
            "DEV-0243",
            "UNC2165"
        ],
        "objectives": [
            "Ransomware"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1136",
                "name": "Create Account"
            },
            {
                "id": "T1112",
                "name": "Modify Registry"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1583",
                "name": "Acquire Infrastructure"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1021.001",
                "name": "Remote Desktop Protocol"
            },
            {
                "id": "T1555.005",
                "name": "Password Managers"
            },
            {
                "id": "T1590",
                "name": "Gather Victim Network Information"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1078.002",
                "name": "Domain Accounts"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1484.001",
                "name": "Group Policy Modification"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            },
            {
                "id": "T1486",
                "name": "Data Encrypted for Impact"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1489",
                "name": "Service Stop"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1558.003",
                "name": "Kerberoasting"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1584.004",
                "name": "Server"
            }
        ]
    },
    {
        "id": "G0120",
        "name": "Evilnum",
        "fileName": "G0120-Evilnum.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0120) is a financially motivated threat group that has been active since at least 2018.(Citation: ESET EvilNum July 2020)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1497.001",
                "name": "System Checks"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1539",
                "name": "Steal Web Session Cookie"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1548.002",
                "name": "Bypass User Account Control"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1555",
                "name": "Credentials from Password Stores"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            }
        ]
    },
    {
        "id": "G0121",
        "name": "Sidewinder",
        "fileName": "G0121-Sidewinder.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0121) is a suspected Indian threat actor group that has been active since at least 2012. They have been observed targeting government, military, and business entities throughout Asia, primarily focusing on Pakistan, China, Nepal, and Afghanistan.(Citation: ATT Sidewinder January 2021)(Citation: Securelist APT Trends April 2018)(Citation: Cyble Sidewinder September 2020)",
        "aliases": [
            "T-APT-04",
            "Rattlesnake"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1020",
                "name": "Automated Exfiltration"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1559.002",
                "name": "Dynamic Data Exchange"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1598.002",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            }
        ]
    },
    {
        "id": "G0122",
        "name": "Silent Librarian",
        "fileName": "G0122-Silent Librarian.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0122) is a group that has targeted research and proprietary data at universities, government agencies, and private sector companies worldwide since at least 2013. Members of  (https://attack.mitre.org/groups/G0122) are known to have been affiliated with the Iran-based Mabna Institute which has conducted cyber intrusions at the behest of the government of Iran, specifically the Islamic Revolutionary Guard Corps (IRGC).(Citation: DOJ Iran Indictments March 2018)(Citation: Phish Labs Silent Librarian)(Citation: Malwarebytes Silent Librarian October 2020)",
        "aliases": [
            "TA407",
            "COBALT DICKENS"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1588.004",
                "name": "Digital Certificates"
            },
            {
                "id": "T1594",
                "name": "Search Victim-Owned Websites"
            },
            {
                "id": "T1114",
                "name": "Email Collection"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1589.003",
                "name": "Employee Names"
            },
            {
                "id": "T1114.003",
                "name": "Email Forwarding Rule"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1608.005",
                "name": "Link Target"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1078",
                "name": "Valid Accounts"
            }
        ]
    },
    {
        "id": "G0123",
        "name": "Volatile Cedar",
        "fileName": "G0123-Volatile Cedar.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0123) is a Lebanese threat group that has targeted individuals, companies, and institutions worldwide. (https://attack.mitre.org/groups/G0123) has been operating since 2012 and is motivated by political and ideological interests.(Citation: CheckPoint Volatile Cedar March 2015)(Citation: ClearSky Lebanese Cedar Jan 2021)",
        "aliases": [
            "Lebanese Cedar"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1595.003",
                "name": "Wordlist Scanning"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            }
        ]
    },
    {
        "id": "G0124",
        "name": "Windigo",
        "fileName": "G0124-Windigo.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "The (https://attack.mitre.org/groups/G0124) group has been operating since at least 2011, compromising thousands of Linux and Unix servers using the (https://attack.mitre.org/software/S0377) SSH backdoor to create a spam botnet. Despite law enforcement intervention against the creators, (https://attack.mitre.org/groups/G0124) operators continued updating (https://attack.mitre.org/software/S0377) through 2019.(Citation: ESET Windigo Mar 2014)(Citation: CERN Windigo June 2019)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1090",
                "name": "Proxy"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            }
        ]
    },
    {
        "id": "G0125",
        "name": "HAFNIUM",
        "fileName": "G0125-HAFNIUM.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0125) is a likely state-sponsored cyber espionage group operating out of China that has been active since at least January 2021. (https://attack.mitre.org/groups/G0125) primarily targets entities in the US across a number of industry sectors, including infectious disease researchers, law firms, higher education institutions, defense contractors, policy think tanks, and NGOs. (https://attack.mitre.org/groups/G0125) has targeted remote management tools and cloud software for intial access and has demonstrated an ability to quickly operationalize exploits for identified vulnerabilities in edge devices.(Citation: Microsoft HAFNIUM March 2020)(Citation: Volexity Exchange Marauder March 2021)(Citation: Microsoft Silk Typhoon MAR 2025)",
        "aliases": [
            "Operation Exchange Marauder",
            "Silk Typhoon"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Defense",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1592.004",
                "name": "Client Configurations"
            },
            {
                "id": "T1110.003",
                "name": "Password Spraying"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1583.005",
                "name": "Botnet"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1213.002",
                "name": "Sharepoint"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1584.005",
                "name": "Botnet"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1530",
                "name": "Data from Cloud Storage"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1590",
                "name": "Gather Victim Network Information"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1555.006",
                "name": "Cloud Secrets Management Stores"
            },
            {
                "id": "T1593.003",
                "name": "Code Repositories"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1114.002",
                "name": "Remote Email Collection"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1078.003",
                "name": "Local Accounts"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1016.001",
                "name": "Internet Connection Discovery"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1590.005",
                "name": "IP Addresses"
            },
            {
                "id": "T1199",
                "name": "Trusted Relationship"
            },
            {
                "id": "T1078.004",
                "name": "Cloud Accounts"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1098",
                "name": "Account Manipulation"
            },
            {
                "id": "T1136.002",
                "name": "Domain Account"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1550.001",
                "name": "Application Access Token"
            },
            {
                "id": "T1685.005",
                "name": "Clear Windows Event Logs"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1583.003",
                "name": "Virtual Private Server"
            }
        ]
    },
    {
        "id": "G0126",
        "name": "Higaisa",
        "fileName": "G0126-Higaisa.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0126) is a threat group suspected to have South Korean origins. (https://attack.mitre.org/groups/G0126) has targeted government, public, and trade organizations in North Korea; however, they have also carried out attacks in China, Japan, Russia, Poland, and other nations. (https://attack.mitre.org/groups/G0126) was first disclosed in early 2019 but is assessed to have operated as early as 2009.(Citation: Malwarebytes Higaisa 2020)(Citation: Zscaler Higaisa 2020)(Citation: PTSecurity Higaisa 2020)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1090.001",
                "name": "Internal Proxy"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1001.003",
                "name": "Protocol or Service Impersonation"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1029",
                "name": "Scheduled Transfer"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1027.001",
                "name": "Binary Padding"
            },
            {
                "id": "T1027.015",
                "name": "Compression"
            },
            {
                "id": "T1220",
                "name": "XSL Script Processing"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            }
        ]
    },
    {
        "id": "G0127",
        "name": "TA551",
        "fileName": "G0127-TA551.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0127) is a financially-motivated threat group that has been active since at least 2018. (Citation: Secureworks GOLD CABIN) The group has primarily targeted English, German, Italian, and Japanese speakers through email-based malware distribution campaigns. (Citation: Unit 42 TA551 Jan 2021)",
        "aliases": [
            "GOLD CABIN",
            "Shathak"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": [
            {
                "id": "T1218.010",
                "name": "Regsvr32"
            },
            {
                "id": "T1589.002",
                "name": "Email Addresses"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1218.011",
                "name": "Rundll32"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1132.001",
                "name": "Standard Encoding"
            },
            {
                "id": "T1568.002",
                "name": "Domain Generation Algorithms"
            },
            {
                "id": "T1027.010",
                "name": "Command Obfuscation"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            }
        ]
    },
    {
        "id": "G0128",
        "name": "ZIRCONIUM",
        "fileName": "G0128-ZIRCONIUM.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0128) is a threat group operating out of China, active since at least 2017, that has targeted individuals associated with the 2020 US presidential election and prominent leaders in the international affairs community.(Citation: Microsoft Targeting Elections September 2020)(Citation: Check Point APT31 February 2021)",
        "aliases": [
            "APT31",
            "Violet Typhoon"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1598",
                "name": "Phishing for Information"
            },
            {
                "id": "T1012",
                "name": "Query Registry"
            },
            {
                "id": "T1665",
                "name": "Hide Infrastructure"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1584.008",
                "name": "Network Devices"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1124",
                "name": "System Time Discovery"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1033",
                "name": "System Owner/User Discovery"
            },
            {
                "id": "T1090.003",
                "name": "Multi-hop Proxy"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1218.007",
                "name": "Msiexec"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1102.002",
                "name": "Bidirectional Communication"
            }
        ]
    },
    {
        "id": "G0129",
        "name": "Mustang Panda",
        "fileName": "G0129-Mustang Panda.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0129) is a China-based cyber espionage threat actor that has been conducting operations since at least 2012. (https://attack.mitre.org/groups/G0129) has been known to use tailored phishing lures and decoy documents to deliver malicious payloads.  (https://attack.mitre.org/groups/G0129) has targeted government, diplomatic, and non-governmental organizations, including think tanks, religious institutions, and research entities, across the United States, Europe, and Asia, with notable activity in Russia, Mongolia, Myanmar, Pakistan, and Vietnam. (Citation: BlackBerry MUSTANG PANDA October 2022)(Citation: Eset PlugX Korplug Mustang Panda March 2022)(Citation: Anomali MUSTANG PANDA October 2019)(Citation: Cisco Talos MUSTANG PANDA PLUGX PUBLOAD MAY 2022)(Citation: Secureworks BRONZE PRESIDENT December 2019)(Citation: DOJ Affidavit Search and Seizure PlugX December 2024)(Citation: EclecticIQ Mustang Panda PlugX)(Citation: ATTACKIQ MUSTANG PANDA TONESHELL March 2023)(Citation: Crowdstrike MUSTANG PANDA June 2018)(Citation: Palo Alto Networks, Unit 42)(Citation: Sophos PlugX September 2022)(Citation: Sophos Mustang Panda PLUGX)(Citation: Zscaler)",
        "aliases": [
            "TA416",
            "RedDelta",
            "BRONZE PRESIDENT",
            "STATELY TAURUS",
            "FIREANT",
            "CAMARO DRAGON",
            "EARTH PRETA",
            "HIVE0154",
            "TWILL TYPHOON",
            "TANTALUM",
            "LUMINOUS MOTH",
            "UNC6384",
            "TEMP.Hex",
            "Red Lich",
            "ClumsyToad"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1047",
                "name": "Windows Management Instrumentation"
            },
            {
                "id": "T1573.001",
                "name": "Symmetric Cryptography"
            },
            {
                "id": "T1593",
                "name": "Search Open Websites/Domains"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1219.001",
                "name": "IDE Tunneling"
            },
            {
                "id": "T1567.002",
                "name": "Exfiltration to Cloud Storage"
            },
            {
                "id": "T1053.005",
                "name": "Scheduled Task"
            },
            {
                "id": "T1087.002",
                "name": "Domain Account"
            },
            {
                "id": "T1598.003",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1678",
                "name": "Delay Execution"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1218.005",
                "name": "Mshta"
            },
            {
                "id": "T1027.007",
                "name": "Dynamic API Resolution"
            },
            {
                "id": "T1585.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1219.002",
                "name": "Remote Desktop Software"
            },
            {
                "id": "T1218.004",
                "name": "InstallUtil"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1560.001",
                "name": "Archive via Utility"
            },
            {
                "id": "T1070",
                "name": "Indicator Removal"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1018",
                "name": "Remote System Discovery"
            },
            {
                "id": "T1069.002",
                "name": "Domain Groups"
            },
            {
                "id": "T1001.003",
                "name": "Protocol or Service Impersonation"
            },
            {
                "id": "T1048.003",
                "name": "Exfiltration Over Unencrypted Non-C2 Protocol"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1041",
                "name": "Exfiltration Over C2 Channel"
            },
            {
                "id": "T1072",
                "name": "Software Deployment Tools"
            },
            {
                "id": "T1557",
                "name": "Adversary-in-the-Middle"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1176.002",
                "name": "IDE Extensions"
            },
            {
                "id": "T1588.003",
                "name": "Code Signing Certificates"
            },
            {
                "id": "T1091",
                "name": "Replication Through Removable Media"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1052.001",
                "name": "Exfiltration over USB"
            },
            {
                "id": "T1003.001",
                "name": "LSASS Memory"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1588.004",
                "name": "Digital Certificates"
            },
            {
                "id": "T1560.003",
                "name": "Archive via Custom Method"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1129",
                "name": "Shared Modules"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1574.005",
                "name": "Executable Installer File Permissions Weakness"
            },
            {
                "id": "T1608",
                "name": "Stage Capabilities"
            },
            {
                "id": "T1622",
                "name": "Debugger Evasion"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1654",
                "name": "Log Enumeration"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1518",
                "name": "Software Discovery"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1546.003",
                "name": "Windows Management Instrumentation Event Subscription"
            },
            {
                "id": "T1106",
                "name": "Native API"
            },
            {
                "id": "T1003.003",
                "name": "NTDS"
            },
            {
                "id": "T1059",
                "name": "Command and Scripting Interpreter"
            },
            {
                "id": "T1553.002",
                "name": "Code Signing"
            },
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1119",
                "name": "Automated Collection"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1059.007",
                "name": "JavaScript"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1027.016",
                "name": "Junk Code Insertion"
            },
            {
                "id": "T1070.006",
                "name": "Timestomp"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1572",
                "name": "Protocol Tunneling"
            },
            {
                "id": "T1036.008",
                "name": "Masquerade File Type"
            },
            {
                "id": "T1036.007",
                "name": "Double File Extension"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1205",
                "name": "Traffic Signaling"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1027.012",
                "name": "LNK Icon Smuggling"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            },
            {
                "id": "T1003.006",
                "name": "DCSync"
            }
        ]
    },
    {
        "id": "G0130",
        "name": "Ajax Security Team",
        "fileName": "G0130-Ajax Security Team.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0130) is a group that has been active since at least 2010 and believed to be operating out of Iran. By 2014 (https://attack.mitre.org/groups/G0130) transitioned from website defacement operations to malware-based cyber espionage campaigns targeting the US defense industrial base and Iranian users of anti-censorship technologies.(Citation: FireEye Operation Saffron Rose 2013)",
        "aliases": [
            "Operation Woolen-Goldfish",
            "AjaxTM",
            "Rocket Kitten",
            "Flying Kitten",
            "Operation Saffron Rose"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1566.003",
                "name": "Spearphishing via Service"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1555.003",
                "name": "Credentials from Web Browsers"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            }
        ]
    },
    {
        "id": "G0131",
        "name": "Tonto Team",
        "fileName": "G0131-Tonto Team.html",
        "severity": "high",
        "country": "China",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0131) is a suspected Chinese state-sponsored cyber espionage threat group that has primarily targeted South Korea, Japan, Taiwan, and the United States since at least 2009; by 2020 they expanded operations to include other Asian as well as Eastern European countries. (https://attack.mitre.org/groups/G0131) has targeted government, military, energy, mining, financial, education, healthcare, and technology organizations, including through the Heartbeat Campaign (2009-2012) and Operation Bitter Biscuit (2017).(Citation: Kaspersky CactusPete Aug 2020)(Citation: ESET Exchange Mar 2021)(Citation: FireEye Chinese Espionage October 2019)(Citation: ARS Technica China Hack SK April 2017)(Citation: Trend Micro HeartBeat Campaign January 2013)(Citation: Talos Bisonal 10 Years March 2020)",
        "aliases": [
            "Earth Akhlut",
            "BRONZE HUNTLEY",
            "CactusPete",
            "Karma Panda"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Healthcare",
            "Financial",
            "Energy",
            "Government",
            "Technology",
            "Education"
        ],
        "techniques": [
            {
                "id": "T1135",
                "name": "Network Share Discovery"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1090.002",
                "name": "External Proxy"
            },
            {
                "id": "T1059.006",
                "name": "Python"
            },
            {
                "id": "T1069.001",
                "name": "Local Groups"
            },
            {
                "id": "T1056.001",
                "name": "Keylogging"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1068",
                "name": "Exploitation for Privilege Escalation"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1210",
                "name": "Exploitation of Remote Services"
            },
            {
                "id": "T1003",
                "name": "OS Credential Dumping"
            }
        ]
    },
    {
        "id": "G0132",
        "name": "CostaRicto",
        "fileName": "G0132-CostaRicto.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0132) is a suspected hacker-for-hire cyber espionage campaign that has targeted multiple industries worldwide since at least 2019. (https://attack.mitre.org/groups/G0132)'s targets, a large portion of which are financial institutions, are scattered across Europe, the Americas, Asia, Australia, and Africa, with a large concentration in South Asia.(Citation: BlackBerry CostaRicto November 2020)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Financial"
        ],
        "techniques": []
    },
    {
        "id": "G0133",
        "name": "Nomadic Octopus",
        "fileName": "G0133-Nomadic Octopus.html",
        "severity": "high",
        "country": "Russia",
        "firstSeen": "Unknown",
        "description": "",
        "aliases": [
            "DustSquad"
        ],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1564.003",
                "name": "Hidden Window"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            }
        ]
    },
    {
        "id": "G0134",
        "name": "Transparent Tribe",
        "fileName": "G0134-Transparent Tribe.html",
        "severity": "high",
        "country": "Pakistan",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0134) is a suspected Pakistan-based threat group that has been active since at least 2013, primarily targeting diplomatic, defense, and research organizations in India and Afghanistan.(Citation: Proofpoint Operation Transparent Tribe March 2016)(Citation: Kaspersky Transparent Tribe August 2020)(Citation: Talos Transparent Tribe May 2021)",
        "aliases": [
            "COPPER FIELDSTONE",
            "APT36",
            "Mythic Leopard",
            "ProjectM"
        ],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Defense"
        ],
        "techniques": [
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1608.004",
                "name": "Drive-by Target"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1568",
                "name": "Dynamic Resolution"
            },
            {
                "id": "T1584.001",
                "name": "Domains"
            },
            {
                "id": "T1059.005",
                "name": "Visual Basic"
            },
            {
                "id": "T1566.002",
                "name": "Spearphishing Link"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1564.001",
                "name": "Hidden Files and Directories"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.001",
                "name": "Malicious Link"
            }
        ]
    },
    {
        "id": "G0135",
        "name": "BackdoorDiplomacy",
        "fileName": "G0135-BackdoorDiplomacy.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0135) is a cyber espionage threat group that has been active since at least 2017. (https://attack.mitre.org/groups/G0135) has targeted Ministries of Foreign Affairs and telecommunication companies in Africa, Europe, the Middle East, and Asia.(Citation: ESET BackdoorDiplomacy Jun 2021)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1027",
                "name": "Obfuscated Files or Information"
            },
            {
                "id": "T1505.003",
                "name": "Web Shell"
            },
            {
                "id": "T1190",
                "name": "Exploit Public-Facing Application"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1055.001",
                "name": "Dynamic-link Library Injection"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1095",
                "name": "Non-Application Layer Protocol"
            },
            {
                "id": "T1574.001",
                "name": "DLL"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1036.004",
                "name": "Masquerade Task or Service"
            }
        ]
    },
    {
        "id": "G0136",
        "name": "IndigoZebra",
        "fileName": "G0136-IndigoZebra.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0136) is a suspected Chinese cyber espionage group that has been targeting Central Asian governments since at least 2014.(Citation: HackerNews IndigoZebra July 2021)(Citation: Checkpoint IndigoZebra July 2021)(Citation: Securelist APT Trends Q2 2017)",
        "aliases": [],
        "objectives": [
            "Espionage"
        ],
        "industries": [
            "Government"
        ],
        "techniques": [
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1583.006",
                "name": "Web Services"
            },
            {
                "id": "T1586.002",
                "name": "Email Accounts"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            }
        ]
    },
    {
        "id": "G0137",
        "name": "Ferocious Kitten",
        "fileName": "G0137-Ferocious Kitten.html",
        "severity": "high",
        "country": "Iran",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0137) is a threat group that has primarily targeted Persian-speaking individuals in Iran since at least 2015.(Citation: Kaspersky Ferocious Kitten Jun 2021)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1036.002",
                "name": "Right-to-Left Override"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1588.002",
                "name": "Tool"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            }
        ]
    },
    {
        "id": "G0138",
        "name": "Andariel",
        "fileName": "G0138-Andariel.html",
        "severity": "high",
        "country": "North Korea",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0138) is a North Korean state-sponsored threat group that has been active since at least 2009. (https://attack.mitre.org/groups/G0138) has primarily focused its operations--which have included destructive attacks--against South Korean government agencies, military organizations, and a variety of domestic companies; they have also conducted cyber financial operations against ATMs, banks, and cryptocurrency exchanges. (https://attack.mitre.org/groups/G0138)'s notable activity includes Operation Black Mine, Operation GoldenAxe, and Campaign Rifle.(Citation: FSI Andariel Campaign Rifle July 2017)(Citation: IssueMakersLab Andariel GoldenAxe May 2017)(Citation: AhnLab Andariel Subgroup of Lazarus June 2018)(Citation: TrendMicro New Andariel Tactics July 2018)(Citation: CrowdStrike Silent Chollima Adversary September 2021)",
        "aliases": [
            "Silent Chollima",
            "PLUTONIUM",
            "Onyx Sleet"
        ],
        "objectives": [
            "Destructive"
        ],
        "industries": [
            "Financial",
            "Government"
        ],
        "techniques": [
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1203",
                "name": "Exploitation for Client Execution"
            },
            {
                "id": "T1005",
                "name": "Data from Local System"
            },
            {
                "id": "T1590.005",
                "name": "IP Addresses"
            },
            {
                "id": "T1189",
                "name": "Drive-by Compromise"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1592.002",
                "name": "Software"
            },
            {
                "id": "T1588.001",
                "name": "Malware"
            },
            {
                "id": "T1204.002",
                "name": "Malicious File"
            },
            {
                "id": "T1566.001",
                "name": "Spearphishing Attachment"
            },
            {
                "id": "T1027.003",
                "name": "Steganography"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            }
        ]
    },
    {
        "id": "G0139",
        "name": "TeamTNT",
        "fileName": "G0139-TeamTNT.html",
        "severity": "high",
        "country": "Unknown",
        "firstSeen": "Unknown",
        "description": "(https://attack.mitre.org/groups/G0139) is a threat group that has primarily targeted cloud and containerized environments. The group as been active since at least October 2019 and has mainly focused its efforts on leveraging cloud and container resources to deploy cryptocurrency miners in victim environments.(Citation: Palo Alto Black-T October 2020)(Citation: Lacework TeamTNT May 2021)(Citation: Intezer TeamTNT September 2020)(Citation: Cado Security TeamTNT Worm August 2020)(Citation: Unit 42 Hildegard Malware)(Citation: Trend Micro TeamTNT)(Citation: ATT TeamTNT Chimaera September 2020)(Citation: Aqua TeamTNT August 2020)(Citation: Intezer TeamTNT Explosion September 2021)",
        "aliases": [],
        "objectives": [
            "Intelligence Gathering"
        ],
        "industries": [
            "Multiple Sectors"
        ],
        "techniques": [
            {
                "id": "T1680",
                "name": "Local Storage Discovery"
            },
            {
                "id": "T1686",
                "name": "Disable or Modify System Firewall"
            },
            {
                "id": "T1133",
                "name": "External Remote Services"
            },
            {
                "id": "T1219",
                "name": "Remote Access Tools"
            },
            {
                "id": "T1569.003",
                "name": "Systemctl"
            },
            {
                "id": "T1036.005",
                "name": "Match Legitimate Resource Name or Location"
            },
            {
                "id": "T1222.002",
                "name": "Linux and Mac Permissions"
            },
            {
                "id": "T1070.004",
                "name": "File Deletion"
            },
            {
                "id": "T1609",
                "name": "Container Administration Command"
            },
            {
                "id": "T1059.004",
                "name": "Unix Shell"
            },
            {
                "id": "T1547.001",
                "name": "Registry Run Keys / Startup Folder"
            },
            {
                "id": "T1543.002",
                "name": "Systemd Service"
            },
            {
                "id": "T1136.001",
                "name": "Local Account"
            },
            {
                "id": "T1007",
                "name": "System Service Discovery"
            },
            {
                "id": "T1049",
                "name": "System Network Connections Discovery"
            },
            {
                "id": "T1543.003",
                "name": "Windows Service"
            },
            {
                "id": "T1608.001",
                "name": "Upload Malware"
            },
            {
                "id": "T1059.003",
                "name": "Windows Command Shell"
            },
            {
                "id": "T1613",
                "name": "Container and Resource Discovery"
            },
            {
                "id": "T1048",
                "name": "Exfiltration Over Alternative Protocol"
            },
            {
                "id": "T1057",
                "name": "Process Discovery"
            },
            {
                "id": "T1059.001",
                "name": "PowerShell"
            },
            {
                "id": "T1552.005",
                "name": "Cloud Instance Metadata API"
            },
            {
                "id": "T1070.003",
                "name": "Clear Command History"
            },
            {
                "id": "T1074.001",
                "name": "Local Data Staging"
            },
            {
                "id": "T1595.002",
                "name": "Vulnerability Scanning"
            },
            {
                "id": "T1059.013",
                "name": "Container CLI/API"
            },
            {
                "id": "T1027.002",
                "name": "Software Packing"
            },
            {
                "id": "T1204.003",
                "name": "Malicious Image"
            },
            {
                "id": "T1014",
                "name": "Rootkit"
            },
            {
                "id": "T1552.004",
                "name": "Private Keys"
            },
            {
                "id": "T1611",
                "name": "Escape to Host"
            },
            {
                "id": "T1595.001",
                "name": "Scanning IP Blocks"
            },
            {
                "id": "T1105",
                "name": "Ingress Tool Transfer"
            },
            {
                "id": "T1518.001",
                "name": "Security Software Discovery"
            },
            {
                "id": "T1496.001",
                "name": "Compute Hijacking"
            },
            {
                "id": "T1083",
                "name": "File and Directory Discovery"
            },
            {
                "id": "T1021.004",
                "name": "SSH"
            },
            {
                "id": "T1036",
                "name": "Masquerading"
            },
            {
                "id": "T1140",
                "name": "Deobfuscate/Decode Files or Information"
            },
            {
                "id": "T1082",
                "name": "System Information Discovery"
            },
            {
                "id": "T1027.013",
                "name": "Encrypted/Encoded File"
            },
            {
                "id": "T1016",
                "name": "System Network Configuration Discovery"
            },
            {
                "id": "T1046",
                "name": "Network Service Discovery"
            },
            {
                "id": "T1120",
                "name": "Peripheral Device Discovery"
            },
            {
                "id": "T1685",
                "name": "Disable or Modify Tools"
            },
            {
                "id": "T1071",
                "name": "Application Layer Protocol"
            },
            {
                "id": "T1098.004",
                "name": "SSH Authorized Keys"
            },
            {
                "id": "T1583.001",
                "name": "Domains"
            },
            {
                "id": "T1059.009",
                "name": "Cloud API"
            },
            {
                "id": "T1071.001",
                "name": "Web Protocols"
            },
            {
                "id": "T1552.001",
                "name": "Credentials In Files"
            },
            {
                "id": "T1685.006",
                "name": "Clear Linux or Mac System Logs"
            },
            {
                "id": "T1587.001",
                "name": "Malware"
            },
            {
                "id": "T1102",
                "name": "Web Service"
            },
            {
                "id": "T1610",
                "name": "Deploy Container"
            }
        ]
    }
];
